<template>
  <div class="row">
    <div class="col-xl-12">
      <div class="kt-portlet kt-portlet--last kt-portlet--head-lg kt-portlet--responsive-mobile">
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="kt-font-priceTier flaticon2-writing"></i>
            </span>
            <h3 v-if="isEdit" class="kt-portlet__head-title">
              <p class="mt-2 mb-0">
                แก้ไขใบงาน
                <strong>ประเภท{{ jobTypeName }}</strong> เลขที่
                <strong>{{ jobNumber }}</strong>
              </p>
              <p v-if="!isEditable" class="text-danger mt-2 mb-0">
                <i class="flaticon-alert"></i>
                ใบงานนี้ไม่สามารถแก้ไขได้เนื่องจากได้ถูกนำไปใช้งานหรือสแกนบาร์โค้ดแล้ว
                <u>ต้องลบและสร้างใหม่เท่านั้น</u>เพื่อล้างรายการบาร์โค้ดที่ถูกสแกนแล้ว
              </p>
              <p v-if="fromJobNumber" class="text-info mt-2 mb-2">
                <i class="flaticon-questions-circular-button"></i>
                อ้างอิงใบงานต้นทาง
                <strong>{{ fromJobNumber }}</strong>
                (ประเภท{{ fromJobTypeName }})
              </p>
            </h3>
            <h3 v-else class="kt-portlet__head-title">
              เปิดใบงาน
              <strong>ประเภท{{ $route.meta.breadcrumb }}</strong>
            </h3>
          </div>
          <div class="kt-portlet__head-toolbar">
            <button type="button" @click.prevent="$router.go(-1)" class="btn btn-sm btn-clean kt-margin-r-10">
              <i class="la la-arrow-left"></i>
              <span class="kt-hidden-mobile">กลับ</span>
            </button>
            <button v-if="isEditable" type="button" @click.prevent="formSubmit" class="btn btn-sm btn-primary kt-margin-r-10">
              <i class="la la-save"></i>
              <span class="kt-hidden-mobile">บันทึกข้อมูล</span>
            </button>
            <button type="button" @click.prevent="commit" class="btn btn-sm btn-success kt-margin-r-10" v-if="canCommit()">
              <i class="fa fa-archive"></i>
              <span class="kt-hidden-mobile">ปิดใบงาน</span>
            </button>
            <button type="button" @click.prevent="approvalProcess(true)" class="btn btn-sm btn-success kt-margin-r-10" v-if="hasApproveProcess">
              <i class="fa fa-check"></i>
              <span class="kt-hidden-mobile">อนุมัติ</span>
            </button>
            <button type="button" @click.prevent="approvalProcess(false)" class="btn btn-sm btn-danger" v-if="hasApproveProcess">
              <i class="fa fa-times"></i>
              <span class="kt-hidden-mobile">ไม่อนุมัติ</span>
            </button>
          </div>
        </div>
        <div class="kt-portlet__body">
          <form autocomplete="off" class="kt-form" id="jobForm" ref="jobForm" @submit="formSubmit">
            <div class="kt-section kt-section--first">
              <h3 class="kt-section__title">ข้อมูลพื้นฐาน:</h3>
              <div class="kt-section__body">
                  <div class="row">
                      <div class="col-sm-6 col-md-4 col-xl-3">
                          <div class="form-group">
                              <label class="label-required">วันที่เอกสาร (วว/ดด/ปปปป):</label>
                              <div class="input-group date">
                                  <input :disabled="isEdit"
                                         readonly
                                         type="text"
                                         class="form-control"
                                         placeholder="วันที่เอกสาร (วว/ดด/ปปปป)"
                                         id="jobDate"
                                         name="jobDate"
                                         ref="jobDate" />
                                  <div class="input-group-append">
                                      <span class="input-group-text">
                                          <i class="la la-calendar"></i>
                                      </span>
                                  </div>
                              </div>
                              <span class="form-text"></span>
                          </div>
                      </div> 
                      <div class="col-sm-6 col-md-4 col-xl-3"
                           v-if="
                      isShowOnJobTypes([
                        'RETRIEVE_NEW_ITEM',
                        'PRODUCE',
                        'DESTROY',
                        'TRANSFER_TO_AGENT',
                        'RETRIEVE_ITEM',
                        'REPAIR',
                        'REPAIR_SUPPLIER',
                        'RETURN_SUPPLIER',
                        'TRANSFER_TO_SHOP',
                        'PICKUP',
                        'RETURN',
                        'RETURN_ADHOC',
                        'EXCHANGE',
                        'BORROW',
                        'HOLD_CHECKER',
                        'NEW_SHOP',
                        'PM_CHECK',
                        'EDIT_NFC',
                        'INSPECTIONS_AND_BORROW_PROPERTY',
                        'BEER_CLAIM',
                        'QI_NO_EQUIPMENT',
                        'TYPING_BARCODE',
                        'QI_LESS_THAN_61',
                        'EDIT_SHOP',
                         'AUDIT_STOCK',
                        'TRANSFER_TO_MULTI_SHOP'
                      ])
                    ">
                          <div class="form-group">
                              <label class="label-required">สถานที่ต้นทาง (Origin):</label>
                              <select2 :disabled="!isEditable"
                                       :css-style="'width: 100%;'"
                                       :css-class="'form-control'"
                                       :id="'originLocationId'"
                                       :name="'originLocationId'"
                                       :select2-options="originLocationIdOptions"
                                       v-model="originLocationId"
                                       ref="originLocationId"
                                       @selectChange="onOriginLocationChange"></select2>
                              <span class="form-text"></span>
                              <label class="kt-checkbox kt-checkbox--brand"
                                     v-if="
                          isShowOnJobTypes([
                            'TRANSFER_TO_AGENT',
                            'TRANSFER_TO_SHOP',
                            'TRANSFER_TO_MULTI_SHOP',
                            'EXCHANGE',
                            'BORROW', 
                            ['RETRIEVE_ITEM', 'JOB_TYPE_TRANSFER_TO_AGENT'],
                            ['RETRIEVE_ITEM', 'JOB_TYPE_TRANSFER_TO_SHOP'],
                            ['RETRIEVE_ITEM', 'JOB_TYPE_EXCHANGE'],
                            ['RETRIEVE_ITEM', 'JOB_TYPE_BORROW'],
                          ])
                        ">
                                  <input type="checkbox" v-model="pickupAtOrigin" v-bind:value="true" :disabled="!isEditable || !canPickupAtOriginMultiShop || isSubAgentOrShop" />

                                  ลูกค้ามารับสินค้าเอง
                                  <template v-if="!isShowOnJobTypes('EXCHANGE')">
                                      (ปลายทางต้องมีเพียงรายเดียวเท่านั้น)
                                  </template>

                                  <span></span>
                              </label>
                              <br v-if="isShowOnJobTypes('EXCHANGE')">
                              <label class="kt-checkbox kt-checkbox--danger"
                                     v-if="
                          isShowOnJobTypes([
                            'TRANSFER_TO_SHOP', ['RETRIEVE_ITEM', 'JOB_TYPE_TRANSFER_TO_SHOP'],
                            'RETURN', ['RETRIEVE_ITEM', 'JOB_TYPE_RETURN'],
                            'EXCHANGE', ['RETRIEVE_ITEM', 'JOB_TYPE_EXCHANGE'],
                            'PICKUP',
                            ]) &&
                            originData &&
                            !originData.data.noSML &&
                            originData.data.locationType == 'AGENT'
                        ">
                                  <input type="checkbox" v-model="noUseSML" v-bind:value="true" :disabled="!isEditable" />
                                  ไม่อ้างอิงข้อมูลระบบ SML
                                  <span></span>
                              </label>
                              <br v-if="isShowOnJobTypes('PICKUP')">
                              <label class="kt-checkbox kt-checkbox--danger"
                                     v-if="
                          isShowOnJobTypes([
                            'PICKUP',
                            ]) &&
                            originData &&
                            originData.data.locationType == 'AGENT' &&
                            originData.data.isPreviousBalance == true
                        ">
                                  <input type="checkbox" v-model="isPreviousBalance" v-bind:value="true" :disabled="(!isEditable || !isEditableTypePICKUP)" />
                                  ยกยอดสินค้าในใบงานเร่ขายไปวันถัดไป
                                  <span></span>
                              </label>
                          </div>
                      </div>
                      <div class="col-sm-6 col-md-4 col-xl-3"
                           v-if="
                      isShowOnJobTypes([
                        'RETRIEVE_ITEM',
                        'REPAIR_SUPPLIER',
                        'RETURN_SUPPLIER',
                        'RETURN',
                        'EXCHANGE',
                        'BEER_CLAIM'
                      ]) ||
                        ($route.meta.jobType == 'BORROW' && !pickupAtOrigin) ||
                        ($route.meta.jobType == 'TRANSFER_TO_SHOP' && originData && originData.data.locationType == 'SHOP') ||
                        ($route.meta.jobType == 'TRANSFER_TO_SHOP' && originData && (originData.data.noSML || noUseSML))
                    ">
                          <div class="form-group">
                              <label class="label-required">สถานที่ปลายทาง (Destination): </label>
                              <select2 :disabled="!isEditable"
                                       :css-style="'width: 100%;'"
                                       :css-class="'form-control'"
                                       :id="'destinationLocationId'"
                                       :name="'destinationLocationId'"
                                       :select2-options="destinationLocationIdOptions"
                                       v-model="destinationLocationId"
                                       ref="destinationLocationId"
                                       @selectChange="onDestinationLocationChange"></select2>
                              <span class="form-text"></span>
                          </div>
                      </div>
                      <!-- รถสำหรับขนส่งสินค้า/ทรัพย์สิน -->
                      <div class="col-sm-6 col-md-4 col-xl-3"
                           v-if="
                          isShowOnJobTypes([
                            'TRANSFER_TO_MULTI_SHOP',
                            ['RETRIEVE_ITEM', 'JOB_TYPE_TRANSFER_TO_MULTI_SHOP'],
                          ])
                        ">
                          <div class="form-group">
                              <label class="label">รถสำหรับขนส่งสินค้า/ทรัพย์สิน:</label>
                              <select2 :disabled="jobStatus != 'JOB_STATUS_WAITING' && jobStatus != 'JOB_STATUS_PENDING' && jobStatus != 'JOB_STATUS_PICKUP'"
                                       :css-style="'width: 100%;'"
                                       :css-class="'form-control'"
                                       :id="'transitId'"
                                       :name="'transitId'"
                                       :select2-options="transportOptions"
                                       @selectChange="onTransitIdChange"
                                       v-model="transitId"
                                       ref="transitId"></select2>
                              <span class="form-text"></span>
                          </div>
                      </div>

    
                      <div class="col-sm-6 col-md-4 col-xl-3"
                           v-if="
                        isShowOnJobTypes([
                          'TRANSFER_TO_SHOP',
                          'RETURN',
                          'EXCHANGE',
                          'PICKUP',
                          'TRANSFER_TO_MULTI_SHOP'
                        ])
                      ">
                          <div class="form-group">
                              <label class="label">เลือก User:</label>
                              <select2 :disabled="!isEditable"
                                       :css-style="'width: 100%;'"
                                       :css-class="'form-control'"
                                       :id="'userIds'"
                                       :name="'userIds'"
                                       :select2-options="userIdsOptions"
                                       :multiple="true"
                                       v-model="userIds"
                                       ref="userIds"></select2>
                              <span class="form-text"></span>
                          </div>
                      </div>

                      <div class="col-sm-6 col-md-4 col-xl-3" v-if="isShowOnJobTypes(['PRODUCE'])">
                          <div class="form-group">
                              <label class="label-required">สินค้าที่ต้องการผลิต:</label>
                              <select2 :css-style="'width: 100%;'"
                                       :css-class="'form-control'"
                                       :id="'finishedProductCode'"
                                       :name="'finishedProductCode'"
                                       :select2-options="finishedProductCodeOptions"
                                       v-model="finishedProductCode"
                                       ref="finishedProductCode"></select2>
                              <span class="form-text"></span>
                          </div>
                      </div>
                   
                      <div class="col-sm-6 col-md-4 col-xl-3"
                           v-if="
                      isShowOnJobTypes([
                        'TRANSFER_TO_AGENT',
                        ['RETRIEVE_ITEM', 'JOB_TYPE_TRANSFER_TO_AGENT'],
                        'RETURN',
                        ['RETRIEVE_ITEM', 'JOB_TYPE_RETURN'],
                        'EXCHANGE',
                        ['RETRIEVE_ITEM', 'JOB_TYPE_EXCHANGE'],
                        'BORROW',
                        ['RETRIEVE_ITEM', 'JOB_TYPE_BORROW'],
                      ])
                    ">
                          <div class="form-group">
                              <label class="label-required">รถสำหรับขนส่งสินค้า/ทรัพย์สิน:</label>
                              <select2 :disabled="jobStatus != 'JOB_STATUS_WAITING' && jobStatus != 'JOB_STATUS_PENDING' && jobStatus != 'JOB_STATUS_PICKUP'"
                                       :css-style="'width: 100%;'"
                                       :css-class="'form-control'"
                                       :id="'transitId'"
                                       :name="'transitId'"
                                       :select2-options="transportOptions"
                                       @selectChange="onTransitIdChange"
                                       v-model="transitId"
                                       ref="transitId"></select2>
                              <span class="form-text"></span>
                          </div>
                      </div>
                      <div class="col-sm-6 col-md-4 col-xl-3" v-if="transitId2">
                          <div class="form-group">
                              <label class="label-required">รถสำหรับขนส่งสินค้า/ทรัพย์สิน ณ จุดรับ:</label>
                              <select2 disabled
                                       :css-style="'width: 100%;'"
                                       :css-class="'form-control'"
                                       :id="'transitId2'"
                                       :name="'transitId2'"
                                       :select2-options="transportOptions"
                                       v-model="transitId2"
                                       ref="transitId2"></select2>
                              <span class="form-text"></span>
                          </div>
                      </div>
                  </div>
              </div>
            </div>

            <!-- Multi Shop Destinations Section - EDITABLE MODE -->
            <div class="kt-section kt-section--first" v-if="isEditable && isShowOnJobTypes(['TRANSFER_TO_MULTI_SHOP'])">
              <div class="kt-section__body">
                <div v-for="(destination, destIndex) in jobDestinations" :key="destination._uid">
                  <!-- Separator between destinations -->
                  <hr v-if="destIndex > 0" style="border-top: 1px solid #e0e0e0; margin: 20px 0;" />
                  
                  <!-- Destination Dropdown with Delete Button -->
                  <div class="row mb-3">
                    <!-- Destination Dropdown (Left) -->
                    <div class="col-sm-12 col-md-6">
                      <div class="form-group">
                        <label class="label-required">
                          สถานที่ปลายทาง (Destination):
                        </label>
                        <select2
                          :disabled="!isEditable"
                          :css-style="'width: 100%;'"
                          :css-class="'form-control required'"
                          :id="'destinationLocationId_' + destIndex"
                          :name="'destinationLocationId_' + destIndex"
                          :select2-options="destinationLocationIdOptions"
                          :data-msg-required="'กรุณาเลือกสถานที่ปลายทาง (Destination)'"
                          v-model="destination.destinationLocationId"
                          :ref="'destinationLocationId_' + destIndex"
                          @selectChange="(id, val, data, ref) => onMultiDestinationChange(id, val, data, ref, destIndex)"
                        ></select2>
                        <span class="form-text"></span>
                      </div>
                    </div>
                    
                    <!-- Delete Button (Right) -->
                    <div class="col-sm-12 col-md-6 text-right" v-if="isEditable && jobDestinations.length > 1">
                      <div class="form-group">
                        <label class="label d-none d-md-block">&nbsp;</label>
                        <button
                          type="button"
                          class="btn btn-danger"
                          @click="onRemoveDestinationClick(destIndex)"
                        >
                          <i class="fa fa-trash"></i> ลบร้านค้านี้
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Items Table -->
                  <h3 class="kt-section__title">รายการสินค้า/ทรัพย์สิน:</h3>
                  <div class="row" >
                    <div class="col-sm-12 table-responsive">
                      <table class="table table-sm table-striped table-bordered table-hover table-checkable">
                        <thead>
                          <tr>
                            <th class="text-center" width="5%">ลำดับ</th>
                            <th class="text-center" width="25%">สินค้า/ทรัพย์สิน</th>
                            <th class="text-center">รายละเอียด</th>
                            <th class="text-center" width="15%">จำนวน</th>
                            <th class="text-center" width="10%">หน่วย</th>
                            <th class="text-center" width="8%">คำสั่ง</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-if="!destination.items || destination.items.length == 0">
                            <td colspan="6" class="text-muted text-center">
                              คลิก + เพื่อเพิ่มรายการใหม่
                            </td>
                          </tr>
                          <template v-for="(item, itemIndex) in destination.items">
                            <job-item-row
                              :ref="'jobItems_' + destIndex + '_' + itemIndex"
                              :key="'dest-' + destIndex + '-item-' + itemIndex"
                              :rowIndex="itemIndex"
                              :item="item"
                              :isEditable="isEditable && !item.isDisabled"
                              :isEdit="isEdit"
                              :jobType="$route.meta.jobType"
                              :originLocationId="originLocationId"
                              :originData="originData"
                              :noUseSML="noUseSML"
                              :parentJobType="parentJobType"
                              @removeItem="(idx) => onRemoveMultiShopItemClick(destIndex, idx)"
                              @showBarcode="onShowBarcodeClick"
                            ></job-item-row>
                          </template>
                        </tbody>
                        <tfoot v-if="isEditable">
                          <tr>
                            <td colspan="6">
                              <button
                                type="button"
                                class="btn btn-sm btn-brand"
                                @click="onAddMultiShopItemClick(destIndex)"
                              >
                                <i class="fa fa-plus"></i> เพิ่มรายการใหม่
                              </button>
                            </td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                </div>

                <!-- Add Destination Button -->
                <div class="row mt-4" v-if="isEditable">
                  <div class="col-sm-12" style="text-align:center;">
                    <button
                      type="button"
                            style="background-color:#FCB53B;color:#fff;"
                      class="btn btn-sm"
                      @click="onAddDestinationClick"
                      :disabled="!originLocationId"
                    >
                      <i class="fa fa-plus"></i> เพิ่มสถานที่ปลายทาง
                    </button>
                    <br />
                    <span class="text-warning" v-if="!originLocationId">
                      กรุณาเลือกสถานที่ต้นทาง (Origin) ก่อน จึงจะสามารถเพิ่มสถานที่ปลายทางได้
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <!-- View Mode: TRANSFER_TO_MULTI_SHOP - Display JobDestinations -->
            <div class="kt-section kt-section--first" v-if="!isEditable && isShowOnJobTypes(['TRANSFER_TO_MULTI_SHOP'])">
              <div class="kt-section__body">
                <h3 class="kt-section__title"><i class="la la-truck"></i> ใบส่งสินค้า:</h3>
                <div class="row">
                  <div class="col-sm-8">
                    <table class="table table-sm table-bordered">
                      <thead>
                        <tr>
                          <th class="text-center font-weight-bold" width="8%" rowspan="2" style="padding: 8px; vertical-align: middle;">ลำดับ</th>
                          <th class="text-center font-weight-bold" width="30%" rowspan="2" style="padding: 8px; vertical-align: middle;">ปลายทาง</th>
                          <th class="text-center font-weight-bold" colspan="3" style="padding: 8px;">รายการสินค้า</th>
                        </tr>
                        <tr>
                          <th class="text-center font-weight-bold" width="35%" style="padding: 8px;">สินค้า</th>
                          <th class="text-center font-weight-bold" width="15%" style="padding: 8px;">จำนวน</th>
                          <th class="text-center font-weight-bold" width="12%" style="padding: 8px;">หน่วย</th>
                        </tr>
                      </thead>
                      <tbody v-if="job.jobDestinations && job.jobDestinations.length > 0">
                        <template v-for="(dest, destIndex) in job.jobDestinations">
                          <!-- กรณีมี items -->
                          <template v-if="dest.items && dest.items.length > 0">
                            <tr v-for="(item, itemIndex) in dest.items" :key="'dest-' + destIndex + '-item-' + itemIndex">
                              <!-- ลำดับ - merge rows ตามจำนวน items + 1 (footer) -->
                              <td v-if="itemIndex === 0" :rowspan="dest.items.length + 1" class="text-center align-middle">
                                {{ destIndex + 1 }}
                              </td>
                              <!-- ปลายทาง - merge rows เฉพาะ items (ไม่รวม footer) -->
                              <td v-if="itemIndex === 0" :rowspan="dest.items.length" class="align-middle">
                                {{ dest.destinationDisplayText || dest.destinationName }}
                              </td>
                              <!-- สินค้า -->
                              <td>{{ item.materialName }} [{{ item.materialCode }}]</td>
                              <!-- จำนวน -->
                              <td class="text-right">{{ formatNumber(item.quantity) }}</td>
                              <!-- หน่วย -->
                              <td class="text-center">{{ item.unitName || '-' }}</td>
                            </tr>
                            <!-- Group Footer: ผลรวมของแต่ละ destination -->
                            <tr :key="'dest-' + destIndex + '-footer'">
                              <!-- คอลัมน์ 1 ถูก merge ไปแล้ว, คอลัมน์ 2,3 merge กัน -->
                              <td class="text-right font-weight-bold"><span style="color:#2015AB;">รวม</span></td>
                              <td></td>
                              <td class="text-right font-weight-bold" style="color:#2015AB;">
                                {{ formatNumber(dest.items.reduce((sum, i) => sum + i.quantity, 0)) }}
                              </td>
                              <td></td>
                            </tr>
                          </template>
                          <!-- กรณีไม่มี items -->
                          <template v-else>
                            <tr :key="'dest-' + destIndex + '-noitems'">
                              <td class="text-center">{{ destIndex + 1 }}</td>
                              <td>{{ dest.destinationName }}</td>
                              <td colspan="3" class="text-muted text-center">ไม่มีรายการสินค้า</td>
                            </tr>
                          </template>
                        </template>
                      </tbody>
                      <tfoot v-if="job.jobDestinations && job.jobDestinations.length > 0">
                        <tr class="font-weight-bold">
                          <td colspan="2" class="text-right" style="text-align:center;"><span style="color:#2015AB;">รวมทั้งหมด</span></td>
                          <td></td>
                          <td class="text-right" style="color:#2015AB;">
                            {{ formatNumber(
                              job.jobDestinations.reduce((total, dest) => 
                                total + (dest.items || []).reduce((sum, item) => sum + item.quantity, 0), 0
                              )
                            ) }}
                          </td>
                          <td></td>
                        </tr>
                      </tfoot>
                      <tbody v-else>
                        <tr>
                          <td colspan="5" class="text-muted text-center">ไม่มีข้อมูลใบส่งสินค้า</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <!-- รายการสินค้า/ทรัพย์สิน สำหรับ TRANSFER_TO_MULTI_SHOP (Read-only Summary) -->
            <div class="kt-section kt-section--first" v-if="!isEditable && isShowOnJobTypes(['TRANSFER_TO_MULTI_SHOP'])">
              <h3 class="kt-section__title">รายการสินค้า/ทรัพย์สิน:</h3>
              <div class="kt-section__body">
                <div class="row">
                  <div class="col-sm-12 table-responsive">
                    <table class="table table-sm table-striped table-bordered table-hover table-checkable">
                      <thead>
                        <tr>
                          <th class="text-center" width="5%">ลำดับ</th>
                          <th class="text-center" width="20%">สินค้า/ทรัพย์สิน</th>
                          <th class="text-center">รายละเอียด</th>
                          <th class="text-center" width="15%">จำนวน</th>
                          <th class="text-center" width="10%">หน่วย</th>
                          <th class="text-center" width="8%">คำสั่ง</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="job.items == null || job.items.length == 0">
                          <td colspan="6" class="text-muted text-center">
                            ไม่มีรายการสินค้า
                          </td>
                        </tr>
                        <tr v-for="(item, i) in job.items" :key="'item-' + i">
                          <td class="text-center">{{ i + 1 }}</td>
                          <td>{{ item.materialName }} [{{ item.materialCode }}]</td>
                          <td>{{ item.description || '-' }}</td>
                          <td class="text-right">
                            {{ formatNumber(item.quantity) }}
                            <span
                              style="display: block;"
                              class="text-info text-right"
                              v-if="item.checkedQuantity > 0"
                            >
                              <i class="fa fa-qrcode"></i>
                              สแกนแล้ว {{ item.checkedQuantity }} บาร์โค้ด
                            </span>
                          </td>
                          <td class="text-center">{{ item.baseUnit || '-' }}</td>
                          <td class="text-center">
                            <button
                              v-if="item.hasBarcode"
                              type="button"
                              class="btn btn-sm btn-outline-info btn-icon"
                              title="แสดงรายการบาร์โค้ด"
                              @click="onShowBarcodeClick(i, item)"
                            >
                              <i class="la la-list"></i>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot v-if="isEdit && (jobStatus == 'JOB_STATUS_WAITING' || jobStatus == 'JOB_STATUS_PENDING')">
                        <tr>
                          <td colspan="2">
                            <!-- ว่างเปล่า (สำหรับคอลัมน์ลำดับและรหัส) -->
                          </td>
                          <td colspan="1">
                            <div class="form-group mb-0">
                              <div class="input-group">
                                <div class="input-group-prepend">
                                  <span class="input-group-text">
                                    <i class="fa fa-barcode"></i>
                                  </span>
                                </div>
                                <textarea
                                  class="form-control form-control-sm"
                                  placeholder="กรอกบาร์โค้ด แล้ว Enter/คลิกปุ่มบันทึกบาร์โค้ด"
                                  v-model="barcodeForm.barcode"
                                  rows="3"
                                ></textarea>
                              </div>
                            </div>
                          </td>
                          <td colspan="4">
                            <button
                              :disabled="barcodeForm.isLoading || !barcodeForm.barcode"
                              type="button"
                              class="btn btn-sm btn-warning"
                              @click.prevent="submitBarcode"
                            >
                              <i class="fa fa-barcode"></i> บันทึกบาร์โค้ด
                            </button>
                            <template v-if="scanBarcodeMessage">
                              <br />
                              <a href="#" @click.prevent="onShowScanModal"><i class="text-info la la-list"></i> {{ scanBarcodeMessage }}</a>
                            </template>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="kt-section kt-section--first"
              v-if="
                isShowOnJobTypes(['REPAIR_SUPPLIER', 'RETURN_SUPPLIER']) ||
                  ($route.meta.jobType == 'DESTROY' && (jobStatus == 'JOB_STATUS_REQUEST_APPROVAL' || jobStatus == 'JOB_STATUS_SUCCESS'))
              "
            >
              <h3 class="kt-section__title">ไฟล์เอกสาร:</h3>
              <div class="kt-section__body">
                <div class="row">
                  <div class="col-sm-12 table-responsive">
                    <table class="table table-sm table-striped table-bordered table-hover table-checkable">
                      <thead>
                        <tr>
                          <th class="text-center" width="5%">ลำดับ</th>
                          <th class="text-center" width="30%">ชื่อเอกสาร</th>
                          <th class="text-center" width="30%">ชื่อไฟล์</th>
                          <th class="text-center" width="15%">ประเภทไฟล์</th>
                          <th class="text-center" width="10%">คำสั่ง</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="uploadFiles == null || uploadFiles.length == 0">
                          <td colspan="6" class="text-muted text-center">
                            คลิก
                            <i class="fa fa-upload"></i> เพื่ออัพโหลดไฟล์เอกสาร เช่น ใบเสนอราคา หรือ ใบวางบิล เป็นต้น
                          </td>
                        </tr>
                        <tr v-for="(file, i) in uploadFiles" :key="'upload-item-' + i">
                          <td class="text-center">
                            <span class="form-control form-control-plaintext">{{ i + 1 }}</span>
                          </td>
                          <td class="form-group">
                            <input type="text" class="form-control" placeholder="ชื่อเอกสาร" :readonly="!isEditable" v-model="file.documentName" />
                            <span class="form-text"></span>
                          </td>
                          <td class="text-center">
                            <a v-if="file.isPreview" 
                              class="form-control form-control-plaintext"
                              href="javascript:void(0)"
                              @click="openPreview(file.fileURL)"
                              >{{ file.fileName }}</a
                            >
                            <a v-else 
                              class="form-control form-control-plaintext"
                              target="blank"
                              :href="`/Api/File/FileDownloadByte?FileInfoId=${file.fileInfoId}&ContentType=${encodeURIComponent(file.contentType)}&FileName=${encodeURIComponent(file.fileName)}`"
                              >{{ file.fileName }}</a
                            >
                          </td>
                          <td class="text-center">
                            <span class="form-control form-control-plaintext">{{ file.contentType }}</span>
                          </td>
                          <td class="text-center">
                            <button
                              v-if="isEditable || ($route.meta.jobType == 'DESTROY' && jobStatus == 'JOB_STATUS_REQUEST_APPROVAL')"
                              type="button"
                              class="btn btn-outline-hover-danger btn-elevate btn-circle btn-icon"
                              title="ลบไฟล์"
                              @click="onRemoveUploadFileClick(i, file)"
                            >
                              <i class="text-danger la la-trash"></i>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot
                        v-if="
                          (isEditable && $route.meta.jobType != 'RETRIEVE_ITEM') ||
                            ($route.meta.jobType == 'DESTROY' && jobStatus == 'JOB_STATUS_REQUEST_APPROVAL')
                        "
                      >
                        <tr>
                          <td colspan="8">
                            <span ref="uploadFileBtnContainer">
                              <button type="button" class="btn btn-sm btn-brand" ref="uploadFileBtn">
                                <i class="fa fa-upload"></i> อัพโหลดไฟล์เอกสาร
                              </button>
                            </span>
                            <a
                              v-if="$route.meta.jobType == 'DESTROY'"
                              type="button"
                              class="btn btn-sm btn-info"
                              target="_blank"
                              v-bind:href="'/Print/DestroyRequestForm/' + $route.params.id"
                            >
                              <i class="fa fa-print"></i> พิมพ์ใบส่งรอทำลาย
                            </a>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div class="kt-section kt-section--first" v-if="isShowOnJobTypes(['TRANSFER_TO_AGENT', ['RETRIEVE_ITEM', 'JOB_TYPE_TRANSFER_TO_AGENT']])">
              <h3 class="kt-section__title">ใบส่งสินค้า (Delivery Order):</h3>
              <div class="kt-section__body">
                <div class="row">
                  <div class="col-sm-12 table-responsive">
                    <table class="table table-sm table-striped table-bordered table-hover table-checkable">
                      <thead>
                        <tr>
                          <th class="text-center align-middle" width="5%" rowspan="2">
                            ลำดับ
                          </th>
                          <th class="text-center align-middle" width="10%" rowspan="2">
                            เลขที่ใบส่งสินค้า
                          </th>
                          <th class="text-center align-middle" width="10%" rowspan="2">
                            วันที่เอกสาร
                          </th>
                          <th class="text-center align-middle" width="20%" rowspan="2">
                            ปลายทาง (Ship To)
                          </th>
                          <th class="text-center" colspan="3">รายการสินค้า</th>
                          <th class="text-center align-middle" width="8%" rowspan="2"  >
                            คำสั่ง
                          </th>
                        </tr>
                        <tr>
                          <th class="text-center">สินค้า</th>
                          <th class="text-center" width="15%">จำนวน</th>
                          <th class="text-center" width="15%">หน่วย</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="refDocuments == null || refDocuments.length == 0">
                          <td colspan="8" class="text-muted text-center">
                            คลิก
                            <i class="fa fa-upload"></i> เพื่อนำเข้าใบส่งสินค้า (Delivery Order)
                          </td>
                        </tr>
                        <template v-for="(item, i) in refDocuments">
                          <template v-if="item.items.length > 0">
                            <job-ref-document-row
                              v-for="(prod, j) in item.items"
                              ref="jobRefDocuments"
                              :key="prod.docNumber"
                              :rowIndex="i"
                              :itemIndex="j"
                              :showHeader="j == 0"
                              :rootItems="refDocuments"
                              :item="item"
                              :isEditable="isEditable"
                              :isEdit="isEdit"
                              :jobType="$route.meta.jobType"
                              @removeItem="onRemoveRefDocumentClick"
                            ></job-ref-document-row>
                          </template>
                          <template v-else>
                            <job-ref-document-row
                              ref="jobRefDocuments"
                              :key="item.id"
                              :rowIndex="i"
                              :itemIndex="0"
                              :rootItems="refDocuments"
                              :item="item"
                              :isEditable="isEditable"
                              :isEdit="isEdit"
                              :jobType="$route.meta.jobType"
                              :showHeader="true"
                              @removeItem="onRemoveRefDocumentClick"
                            ></job-ref-document-row>
                          </template>
                        </template>
                      </tbody>
                      <tfoot v-if="isEditable && $route.meta.jobType != 'RETRIEVE_ITEM'">
                        <tr>
                          <td colspan="8">
                            <!-- <button
                              type="button"
                              class="btn btn-sm btn-brand"
                              @click.prevent="onAddRefDocumentClick"
                            >
                              <i class="fa fa-plus"></i> เพิ่มรายการใหม่
                            </button>-->
                            <span ref="uploadDOBtnContainer">
                              <button type="button" class="btn btn-sm btn-brand" ref="uploadDOBtn" :disabled="!originLocationId">
                                <i class="fa fa-upload"></i> อัพโหลดใบส่งสินค้า (Delivery Order) ด้วยไฟล์ .xlsx
                              </button>
                            </span>
                            <button type="button" class="btn btn-sm btn-dark" @click.prevent="onCalculateItemClick">
                              <i class="fa fa-calculator"></i>
                              คำนวณรายการสินค้า/ทรัพย์สิน
                            </button>
                            <br />
                            <span class="text-warning">กรุณาเลือกสถานที่ต้นทาง (Origin) ก่อน จึงจะสามารถอัพโหลดได้</span>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="kt-section kt-section--first"
              v-if="
                isShowOnJobTypes(['TRANSFER_TO_SHOP', ['RETRIEVE_ITEM', 'JOB_TYPE_TRANSFER_TO_SHOP']]) &&
                  ($route.meta.jobType == 'TRANSFER_TO_SHOP' &&
                    originData &&
                    originData.data.locationType == 'AGENT' &&
                    !originData.data.noSML &&
                    !noUseSML)
              "
            >
              <h3 class="kt-section__title">บิลขาย (Invoice):</h3>
              <div class="kt-section__body">
                <div class="row">
                  <div class="col-sm-12 table-responsive">
                    <table class="table table-sm table-striped table-bordered table-hover table-checkable">
                      <thead>
                        <tr>
                          <th class="text-center align-middle" width="5%" rowspan="2">
                            ลำดับ
                          </th>
                          <th class="text-center align-middle" width="10%" rowspan="2">
                            เลขที่เอกสาร
                          </th>
                          <th class="text-center align-middle" width="10%" rowspan="2">
                            วันที่เอกสาร
                          </th>
                          <th class="text-center align-middle" width="20%" rowspan="2">
                            ปลายทาง (Ship To)
                          </th>
                          <th class="text-center" colspan="3">รายการสินค้า</th>
                          <th class="text-center align-middle" width="8%" rowspan="2">
                            คำสั่ง
                          </th>
                        </tr>
                        <tr>
                          <th class="text-center">สินค้า</th>
                          <th class="text-center" width="15%">จำนวน</th>
                          <th class="text-center" width="15%">หน่วย</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="refInvoices == null || refInvoices.length == 0">
                          <td colspan="8" class="text-muted text-center">
                            คลิก
                            <i class="fa fa-plus"></i> เพื่อเพิ่มบิลใหม่
                          </td>
                        </tr>
                        <template v-for="(item, i) in refInvoices">
                          <template v-if="item.items.length > 0">
                            <job-ref-invoice-row
                              v-for="(prod, j) in item.items"
                              ref="refInvoices"
                              :key="prod.docNumber"
                              :rowIndex="i"
                              :itemIndex="j"
                              :showHeader="j == 0"
                              :rootItems="refInvoices"
                              :item="item"
                              :isEditable="isEditable"
                              :isEdit="isEdit"
                              :jobType="$route.meta.jobType"
                              :agentCode="originLocationId"
                              @removeItem="onRemoveRefInvoiceClick"
                            ></job-ref-invoice-row>
                          </template>
                          <template v-else>
                            <job-ref-invoice-row
                              ref="refInvoices"
                              :key="item.id"
                              :rowIndex="i"
                              :itemIndex="0"
                              :rootItems="refInvoices"
                              :item="item"
                              :isEditable="isEditable"
                              :isEdit="isEdit"
                              :jobType="$route.meta.jobType"
                              :agentCode="originLocationId"
                              :showHeader="true"
                              @removeItem="onRemoveRefInvoiceClick"
                            ></job-ref-invoice-row>
                          </template>
                        </template>
                      </tbody>
                      <tfoot v-if="isEditable && $route.meta.jobType != 'RETRIEVE_ITEM'">
                        <tr>
                          <td colspan="8">
                            <button type="button" class="btn btn-sm btn-brand" @click="onAddRefInvoiceClick" :disabled="!originLocationId">
                              <i class="fa fa-plus"></i> เพิ่มรายการใหม่
                            </button>
                            <button type="button" class="btn btn-sm btn-dark" @click.prevent="onCalculateItemClick">
                              <i class="fa fa-calculator"></i>
                              คำนวณรายการสินค้า/ทรัพย์สิน
                            </button>
                            <br />
                            <span class="text-warning">กรุณาเลือกสถานที่ต้นทาง (Origin) ก่อน จึงจะสามารถเพิ่มรายการใหม่ได้</span>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div class="kt-section kt-section--first" v-if="showRefInvoices">
              <h3 class="kt-section__title">
                <template v-if="$route.meta.jobType == 'PICKUP'">
                  ใบโอนสินค้า:
                </template>
                <template v-else>
                  ใบเบิกสินค้า:
                </template>
              </h3>
              <div class="kt-section__body">
                <div class="row">
                  <div class="col-sm-12 table-responsive">
                    <table class="table table-sm table-striped table-bordered table-hover table-checkable">
                      <thead>
                        <tr>
                          <th class="text-center align-middle" width="5%" rowspan="2">
                            ลำดับ
                          </th>
                          <th class="text-center align-middle" width="10%" rowspan="2">
                            เลขที่เอกสาร
                          </th>
                          <th class="text-center align-middle" width="10%" rowspan="2">
                            วันที่เอกสาร
                          </th>
                          <th class="text-center align-middle" width="20%" rowspan="2">
                            ปลายทาง (Ship To)
                          </th>
                          <th class="text-center" colspan="3">รายการสินค้า</th>
                          <th class="text-center align-middle" width="8%" rowspan="2">
                            คำสั่ง
                          </th>
                        </tr>
                        <tr>
                          <th class="text-center">สินค้า</th>
                          <th class="text-center" width="15%">จำนวน</th>
                          <th class="text-center" width="15%">หน่วย</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="refInvoices == null || refInvoices.length == 0">
                          <td colspan="8" class="text-muted text-center">
                            คลิก
                            <i class="fa fa-plus"></i> เพื่อเพิ่มรายการใหม่
                          </td>
                        </tr>
                        <template v-for="(item, i) in refInvoices">
                          <template v-if="item.items.length > 0">
                            <job-ref-invoice-row
                              v-for="(prod, j) in item.items"
                              ref="refInvoices"
                              :key="prod.docNumber"
                              :rowIndex="i"
                              :itemIndex="j"
                              :showHeader="j == 0"
                              :rootItems="refInvoices"
                              :item="item"
                              :isEditable="isEditable"
                              :isEdit="isEdit"
                              :jobType="$route.meta.jobType"
                              :agentCode="originLocationId"
                              :apiUrl="$route.meta.jobType == 'PICKUP' ? '/Api/Sml/Transfer' : '/Api/Sml/Withdraw'"
                              @removeItem="onRemoveRefInvoiceClick"
                            ></job-ref-invoice-row>
                          </template>
                          <template v-else>
                            <job-ref-invoice-row
                              ref="refInvoices"
                              :key="item.id"
                              :rowIndex="i"
                              :itemIndex="0"
                              :rootItems="refInvoices"
                              :item="item"
                              :isEditable="isEditable"
                              :isEdit="isEdit"
                              :jobType="$route.meta.jobType"
                              :agentCode="originLocationId"
                              :showHeader="true"
                              :apiUrl="$route.meta.jobType == 'PICKUP' ? '/Api/Sml/Transfer' : '/Api/Sml/Withdraw'"
                              @removeItem="onRemoveRefInvoiceClick"
                            ></job-ref-invoice-row>
                          </template>
                        </template>
                      </tbody>
                      <tfoot v-if="isEditable && $route.meta.jobType != 'RETRIEVE_ITEM'">
                        <tr>
                          <td colspan="8">
                            <button type="button" class="btn btn-sm btn-brand" @click="onAddRefInvoiceClick" :disabled="!originLocationId">
                              <i class="fa fa-plus"></i> เพิ่มรายการใหม่
                            </button>
                            <button type="button" class="btn btn-sm btn-dark" @click.prevent="onCalculateItemClick">
                              <i class="fa fa-calculator"></i>
                              คำนวณรายการสินค้า/ทรัพย์สิน
                            </button>
                            <br />
                            <span class="text-warning">กรุณาเลือกสถานที่ต้นทาง (Origin) ก่อน จึงจะสามารถเพิ่มรายการใหม่ได้</span>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div class="kt-section kt-section--first" v-if="refJobs != null && refJobs.length > 0">
              <h3 class="kt-section__title">ใบงานอ้างอิง:</h3>
              <div class="kt-section__body">
                <div class="row">
                  <div class="col-sm-12 table-responsive">
                    <table class="table table-sm table-striped table-bordered table-hover table-checkable">
                      <thead>
                        <tr>
                          <th class="text-center align-middle" width="5%" rowspan="2">
                            ลำดับ
                          </th>
                          <th class="text-center align-middle" width="10%" rowspan="2">
                            เลขที่เอกสาร
                          </th>
                          <th class="text-center align-middle" width="10%" rowspan="2">
                            วันที่เอกสาร
                          </th>
                          <th class="text-center align-middle" width="20%" rowspan="2">
                            สถานที่ต้นทาง (Origin)
                          </th>
                          <th class="text-center align-middle" width="20%" rowspan="2">
                            สถานที่ปลายทาง (Destination)
                          </th>
                          <th class="text-center" colspan="3">รายการสินค้า</th>
                          <th class="text-center align-middle" width="8%" rowspan="2">
                            คำสั่ง
                          </th>
                        </tr>
                        <tr>
                          <th class="text-center">สินค้า</th>
                          <th class="text-center" width="5%">จำนวน</th>
                          <th class="text-center" width="5%">หน่วย</th>
                        </tr>
                      </thead>
                      <tbody>
                        <template v-for="(item, i) in refJobs">
                          <template v-if="item.items.length > 0">
                            <job-ref-job-row
                              v-for="(prod, j) in item.items"
                              ref="refJobs"
                              :key="prod.jobItemId"
                              :rowIndex="i"
                              :itemIndex="j"
                              :showHeader="j == 0"
                              :rootItems="refJobs"
                              :item="item"
                              :isEditable="isEditable"
                              :isEdit="isEdit"
                            ></job-ref-job-row>
                          </template>
                          <template v-else>
                            <job-ref-job-row
                              ref="refJobs"
                              :key="item.jobId"
                              :rowIndex="i"
                              :itemIndex="0"
                              :showHeader="true"
                              :rootItems="refJobs"
                              :item="item"
                              :isEditable="isEditable"
                              :isEdit="isEdit"
                            ></job-ref-job-row>
                          </template>
                        </template>
                      </tbody>
                      <tfoot v-if="isEditable && $route.meta.jobType != 'RETRIEVE_ITEM'">
                        <tr>
                          <td colspan="8">
                            <button type="button" class="btn btn-sm btn-brand" @click="onAddRefInvoiceClick" :disabled="!originLocationId">
                              <i class="fa fa-plus"></i> เพิ่มรายการใหม่
                            </button>
                            <button type="button" class="btn btn-sm btn-dark" @click.prevent="onCalculateItemClick">
                              <i class="fa fa-calculator"></i>
                              คำนวณรายการสินค้า/ทรัพย์สิน
                            </button>
                            <br />
                            <span class="text-warning">กรุณาเลือกสถานที่ต้นทาง (Origin) ก่อน จึงจะสามารถเพิ่มรายการใหม่ได้</span>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div class="kt-section kt-section--first" v-if="productLoan">
              <h3 class="kt-section__title">ใบเบิก/ยืม ทรัพย์สิน:</h3>
              <div class="kt-section__body">
                <div class="row">
                  <div class="col-sm-12 table-responsive">
                    <table class="table table-sm table-striped table-bordered table-hover table-checkable">
                      <thead>
                        <tr>
                          <th class="text-center align-middle" width="10%">
                            เลขที่ใบคำร้อง
                          </th>
                          <th class="text-center align-middle" width="10%">
                            วันที่เอกสาร
                          </th>
                          <th class="text-center align-middle" width="20%">
                            ประเภทใบคำร้อง
                          </th>
                          <th class="text-center align-middle" width="10%">
                            หมวดหมู่
                          </th>
                          <th class="text-center align-middle" width="10%">
                            มูลค่ารวม
                          </th>
                          <th class="text-center align-middle" width="20%">
                            ตัวแทนจำหน่าย / หน่วยงาน
                          </th>
                          <th class="text-center align-middle" width="20%">
                            ผู้ขอเบิกยืม
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td class="text-center">
                            {{ productLoan.requestDocNo }}
                          </td>
                          <td class="text-center">
                            {{ productLoan.requestDateFormat }}
                          </td>
                          <td class="text-center">
                            {{ productLoan.requestTypeName }}
                          </td>
                          <td class="text-center">
                            {{ productLoan.productGroupName }}
                          </td>
                          <td class="text-center">
                            {{ productLoan.amount | currency("", 2) }}
                          </td>
                          <td class="text-center">
                            {{ productLoan.agentOrgName }}
                          </td>
                          <td class="text-center">
                            {{ productLoan.requestUser }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

             <div
              class="kt-section kt-section--first"
              v-if="
                showItems && $route.meta.jobType == 'AUDIT_STOCK' &&
                  (isEdit || $route.meta.jobType != 'RETURN_ADHOC')
              "
            >
              <h3 class="kt-section__title">รายการสินค้า/ทรัพย์สิน:</h3>
              <div class="kt-section__body">
                <div class="row">
                  <div class="col-sm-12 table-responsive">
                    <table class="table table-sm table-striped table-bordered table-hover table-checkable">
                      <thead>
                        <tr>
                          <th class="text-center" width="5%">ลำดับ</th>
                          <th class="text-center" width="25%">สถานะ BARCODE</th>
                          <th class="text-center" width="25%">
                            สินค้า/ทรัพย์สิน
                          </th>
                          <th class="text-center" width="15%">จำนวน</th>
                          <!-- <th class="text-center" width="10%">หน่วย</th>  -->
                          <th class="text-center">หมายเหตุ</th>
                          <th class="text-center" width="8%">คำสั่ง</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="items == null || items.length == 0">
                          <td colspan="6" class="text-muted text-center">
                            คลิก + เพื่อเพิ่มรายการใหม่
                          </td>
                        </tr>
                        <template v-for="(item, i) in items">
                          <job-item-row
                            ref="jobItems"
                            :key="item.jobItemId"
                            :rowIndex="i"
                            :item="item"
                            :allItems="items"
                            :isEditable="isEditable && !item.isDisabled"
                            :isEdit="isEdit"
                            :jobType="$route.meta.jobType"
                            :originLocationId="originLocationId"
                            :originData="originData"
                            :noUseSML="noUseSML"
                            :parentJobType="parentJobType"
                            @removeItem="onRemoveItemClick"
                            @showBarcode="onShowBarcodeClick"
                          ></job-item-row>
                        </template>
                      </tbody>
                      <tfoot>
                        <tr v-if="this.isBeerClaimAdmin">
                          <td colspan="2">
                            <button
                              v-if="
                                isEditable &&
                                  ($route.meta.jobType != 'RETURN_ADHOC' ||
                                    $route.meta.jobType != 'BEER_CLAIM')
                              "
                              type="button"
                              class="btn btn-sm btn-brand"
                              @click.prevent="onAddItemClick"
                            >
                              <i class="fa fa-plus"></i> เพิ่มรายการใหม่
                            </button>
                          </td>
                          <td colspan="1">
                            <div class="form-group mb-0" v-if="isEdit  && (jobStatus == 'JOB_STATUS_WAITING' || jobStatus == 'JOB_STATUS_PENDING')">
                              <div class="input-group" v-if="!isShowOnJobTypes([ 'AUDIT_STOCK' ]) ">
                                <div class="input-group-prepend">
                                  <span class="input-group-text">
                                    <i class="fa fa-barcode"></i>
                                  </span>
                                </div>
                                <textarea
                                  class="form-control form-control-sm"
                                  placeholder="กรอกบาร์โค้ด แล้ว Enter/คลิกปุ่มบันทึกบาร์โค้ด"
                                  v-model="barcodeForm.barcode"
                                  rows="3"
                                ></textarea>
                              </div>
                            </div>
                          </td>
                          <td colspan="3">
                            <button
                              v-if="isEdit && !isShowOnJobTypes([ 'AUDIT_STOCK' ]) && (jobStatus == 'JOB_STATUS_WAITING' || jobStatus == 'JOB_STATUS_PENDING')"
                              :disabled="barcodeForm.isLoading || !barcodeForm.barcode"
                              type="button"
                              class="btn btn-sm btn-warning"
                              @click.prevent="submitBarcode"
                            >
                              <i class="fa fa-barcode"></i> บันทึกบาร์โค้ด
                            </button>
                            <a
                              v-if="isEdit && $route.meta.jobType == 'HOLD_CHECKER'"
                              type="button"
                              class="btn btn-sm btn-info"
                              target="_blank"
                              v-bind:href="'/Print/HoldCheckerForm/' + $route.params.id"
                            >
                              <i class="fa fa-print"></i> พิมพ์ใบ Hold (รับคืน)
                            </a>
                            <template v-if="scanBarcodeMessage">
                              <br />
                              <a href="#" @click.prevent="onShowScanModal"><i class="text-info la la-list"></i> {{ scanBarcodeMessage }}</a>
                            </template>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="kt-section kt-section--first"
              v-if="
                showItems && $route.meta.jobType != 'AUDIT_STOCK' && 
                  (isEdit || $route.meta.jobType != 'RETURN_ADHOC') &&
                  $route.meta.jobType != 'NEW_SHOP' &&
                  $route.meta.jobType != 'PM_CHECK' &&
                  $route.meta.jobType != 'EDIT_NFC' &&
                  $route.meta.jobType != 'INSPECTIONS_AND_BORROW_PROPERTY' &&
                  $route.meta.jobType != 'QI_NO_EQUIPMENT' &&
                  $route.meta.jobType != 'TYPING_BARCODE' &&
                  $route.meta.jobType != 'QI_LESS_THAN_61' &&
                  $route.meta.jobType != 'EDIT_SHOP' &&
                  $route.meta.jobType != 'TRANSFER_TO_MULTI_SHOP' 
              "
            >
              <h3 class="kt-section__title">รายการสินค้า/ทรัพย์สิน:</h3>
              <div class="kt-section__body">
                <div class="row">
                  <div class="col-sm-12 table-responsive">
                    <table class="table table-sm table-striped table-bordered table-hover table-checkable">
                      <thead>
                        <tr>
                          <th class="text-center" width="5%">ลำดับ</th>
                          <th class="text-center" width="25%">
                            สินค้า/ทรัพย์สิน
                          </th>
                          <th class="text-center">รายละเอียด</th>
                          <th class="text-center" width="15%">จำนวน</th>
                          <th class="text-center" width="10%">หน่วย</th>
                          <th class="text-center" width="8%">คำสั่ง</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="items == null || items.length == 0">
                          <td colspan="6" class="text-muted text-center">
                            คลิก + เพื่อเพิ่มรายการใหม่
                          </td>
                        </tr>
                        <template v-for="(item, i) in items">
                          <job-item-row
                            ref="jobItems"
                            :key="item.jobItemId"
                            :rowIndex="i"
                            :item="item"
                            :isEditable="isEditable && !item.isDisabled"
                            :isEdit="isEdit"
                            :jobType="$route.meta.jobType"
                            :originLocationId="originLocationId"
                            :originData="originData"
                            :noUseSML="noUseSML"
                            :parentJobType="parentJobType"
                            @removeItem="onRemoveItemClick"
                            @showBarcode="onShowBarcodeClick"
                          ></job-item-row>
                        </template>
                      </tbody>
                      <tfoot>
                        <tr v-if="this.isBeerClaimAdmin">
                          <td colspan="2">
                            <button
                              v-if="
                                isEditable &&
                                  ($route.meta.jobType != 'RETURN_ADHOC' ||
                                    $route.meta.jobType != 'BEER_CLAIM')
                              "
                              type="button"
                              class="btn btn-sm btn-brand"
                              @click.prevent="onAddItemClick"
                            >
                              <i class="fa fa-plus"></i> เพิ่มรายการใหม่
                            </button>
                          </td>
                          <td colspan="1">
                            <div class="form-group mb-0" v-if="isEdit && (jobStatus == 'JOB_STATUS_WAITING' || jobStatus == 'JOB_STATUS_PENDING')">
                              <div class="input-group">
                                <div class="input-group-prepend">
                                  <span class="input-group-text">
                                    <i class="fa fa-barcode"></i>
                                  </span>
                                </div>
                                <textarea
                                  class="form-control form-control-sm"
                                  placeholder="กรอกบาร์โค้ด แล้ว Enter/คลิกปุ่มบันทึกบาร์โค้ด"
                                  v-model="barcodeForm.barcode"
                                  rows="3"
                                ></textarea>
                              </div>
                            </div>
                          </td>
                          <td colspan="3">
                            <button
                              v-if="isEdit && (jobStatus == 'JOB_STATUS_WAITING' || jobStatus == 'JOB_STATUS_PENDING')"
                              :disabled="barcodeForm.isLoading || !barcodeForm.barcode"
                              type="button"
                              class="btn btn-sm btn-warning"
                              @click.prevent="submitBarcode"
                            >
                              <i class="fa fa-barcode"></i> บันทึกบาร์โค้ด
                            </button>
                            <a
                              v-if="isEdit && $route.meta.jobType == 'HOLD_CHECKER'"
                              type="button"
                              class="btn btn-sm btn-info"
                              target="_blank"
                              v-bind:href="'/Print/HoldCheckerForm/' + $route.params.id"
                            >
                              <i class="fa fa-print"></i> พิมพ์ใบ Hold (รับคืน)
                            </a>
                            <template v-if="scanBarcodeMessage">
                              <br />
                              <a href="#" @click.prevent="onShowScanModal"><i class="text-info la la-list"></i> {{ scanBarcodeMessage }}</a>
                            </template>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div class="kt-section kt-section--first" v-if="ItemHistory && ItemHistory.length > 0">
              <h3 class="kt-section__title">รายการสินค้า/ทรัพย์สิน</h3>
              <div class="kt-section__body">
                <div class="row">
                  <div class="col-sm-12 table-responsive">
                    <table class="table table-sm table-striped table-bordered table-hover table-checkable">
                      <thead>
                        <tr>
                          <th class="text-center" width="5%">ลำดับ</th>
                          <th class="text-center" width="25%">
                            สินค้า/ทรัพย์สิน
                          </th>
                          <th class="text-center">รายละเอียด</th>
                          <th class="text-center" width="15%">จำนวน</th>
                          <th class="text-center" width="10%">หน่วย</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, i) in ItemHistory" :key="'shop-return-item-' + i">
                          <td class="text-center">{{ i + 1 }}</td>
                          <td class="form-group">{{ item.materialName }} [{{ item.materialCode }}]</td>
                          <td class="form-group">{{ item.description }}</td>
                          <td class="form-group text-right">
                            {{ item.quantity | currency("", 0) }}
                          </td>
                          <td class="text-center">{{ item.baseUnit }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div class="kt-section kt-section--first" v-for="(shop, i) in shopItems" :key="'shop-' + i">
              <h3 class="kt-section__title text-success">
                <i class="la la-shopping-cart"></i> รายการสินค้า/ทรัพย์สิน ที่จำหน่ายให้แก่ร้านค้า <strong>{{ shop.shopName }}</strong
                >:
              </h3>
              <div class="kt-section__body">
                <div class="row">
                  <div class="col-sm-3" v-show="showSmlBillNumber">
                    <div class="form-group">
                      <label class="label-required">เลขที่บิลขาย:</label>
                      <input
                        :id="'smlBillNumber_' + i"
                        :name="'smlBillNumber_' + i"
                        type="text"
                        class="form-control sml-bill-number required"
                        placeholder="กรุณากรอกเลขที่บิลขาย"
                        v-model="shop.smlBillNumber"
                      />
                      <span class="form-text">กรุณาสร้างบิลขายภายในระบบ SML เพื่อบันทึกปิดใบงานเร่ขาย</span>
                    </div>
                  </div>
                  <div class="col-sm-3" v-show="!showSmlBillNumber">
                    <div class="form-group">
                      <label class="label-required">ร้านค้าในระบบ:</label>
                      <select2
                        :css-style="'width: 100%;'"
                        :css-class="'form-control'"
                        :id="'shopCode_' + i"
                        :name="'shopCode_' + i"
                        :select2-options="shopCodeOptions"
                        v-model="shop.shopCode"
                        ref="shopCodes"
                      ></select2>
                      <span class="form-text"></span>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label class="label-required">ลายเซ็นต์ผู้รับสินค้า/ทรัพย์สิน:</label>
                      <br />
                      <img style="max-width: 300px;" v-bind:src="shop.signatureFileUrl" />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12 table-responsive">
                    <table class="table table-sm table-striped table-bordered table-hover table-checkable">
                      <thead>
                        <tr>
                          <th class="text-center" width="5%">ลำดับ</th>
                          <th class="text-center" width="25%">
                            สินค้า/ทรัพย์สิน
                          </th>
                          <th class="text-center">รายละเอียด</th>
                          <th class="text-center" width="15%">จำนวน</th>
                          <th class="text-center" width="10%">หน่วย</th>
                          <th class="text-center" width="8%">คำสั่ง</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, i) in shop.items" :key="'shop-item-' + i">
                          <td class="text-center">{{ i + 1 }}</td>
                          <td class="form-group">{{ item.materialName }} [{{ item.materialCode }}]</td>
                          <td class="form-group">{{ item.description }}</td>
                          <td class="form-group text-right">
                            {{ item.quantity | currency("", 0) }}
                          </td>
                          <td class="text-center">{{ item.baseUnit }}</td>
                          <td class="text-center">
                            <button
                              v-if="!isEditable"
                              type="button"
                              class="btn btn-outline-hover-info btn-elevate btn-circle btn-icon"
                              title="แสดงรายการบาร์โค้ด"
                              @click.prevent="onShowLocalBarcodeClick(item)"
                            >
                              <i class="text-info la la-list"></i>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div class="kt-section kt-section--first" v-if="pickupItems && pickupItems.length > 0">
              <h3 class="kt-section__title text-danger"><i class="la la-warning"></i> รายการสินค้า/ทรัพย์สิน นำออกจากคลัง (ยังไม่ได้ขาย):</h3>
              <div class="kt-section__body">
                <div class="row">
                  <div class="col-sm-12 table-responsive">
                    <table class="table table-sm table-striped table-bordered table-hover table-checkable">
                      <thead>
                        <tr>
                          <th class="text-center" width="5%">ลำดับ</th>
                          <th class="text-center" width="25%">
                            สินค้า/ทรัพย์สิน
                          </th>
                          <th class="text-center">รายละเอียด</th>
                          <th class="text-center" width="15%">จำนวน</th>
                          <th class="text-center" width="10%">หน่วย</th>
                          <th class="text-center" width="8%">คำสั่ง</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, i) in pickupItems" :key="'pickup-item-' + i">
                          <td class="text-center">{{ i + 1 }}</td>
                          <td class="form-group">{{ item.materialName }} [{{ item.materialCode }}]</td>
                          <td class="form-group">{{ item.description }}</td>
                          <td class="form-group text-right">
                            {{ item.quantity | currency("", 0) }}
                          </td>
                          <td class="text-center">{{ item.baseUnit }}</td>
                          <td class="text-center">
                            <button
                              v-if="!isEditable"
                              type="button"
                              class="btn btn-outline-hover-info btn-elevate btn-circle btn-icon"
                              title="แสดงรายการบาร์โค้ด"
                              @click.prevent="onShowLocalBarcodeClick(item)"
                            >
                              <i class="text-info la la-list"></i>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div class="kt-section kt-section--first" v-if="pickupReturnItems && pickupReturnItems.length > 0">
              <h3 class="kt-section__title text-info">
                <i class="la la-check-square"></i> รายการสินค้า/ทรัพย์สิน นำออกจากคลัง (ยังไม่ได้ขาย) และนำกลับมาคืนแล้ว:
              </h3>
              <div class="kt-section__body">
                <div class="row">
                  <div class="col-sm-12 table-responsive">
                    <table class="table table-sm table-striped table-bordered table-hover table-checkable">
                      <thead>
                        <tr>
                          <th class="text-center" width="5%">ลำดับ</th>
                          <th class="text-center" width="25%">
                            สินค้า/ทรัพย์สิน
                          </th>
                          <th class="text-center">รายละเอียด</th>
                          <th class="text-center" width="15%">จำนวน</th>
                          <th class="text-center" width="10%">หน่วย</th>
                          <th class="text-center" width="8%">คำสั่ง</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, i) in pickupReturnItems" :key="'pickup-return-item-' + i">
                          <td class="text-center">{{ i + 1 }}</td>
                          <td class="form-group">{{ item.materialName }} [{{ item.materialCode }}]</td>
                          <td class="form-group">{{ item.description }}</td>
                          <td class="form-group text-right">
                            {{ item.quantity | currency("", 0) }}
                          </td>
                          <td class="text-center">{{ item.baseUnit }}</td>
                          <td class="text-center">
                            <button
                              v-if="!isEditable"
                              type="button"
                              class="btn btn-outline-hover-info btn-elevate btn-circle btn-icon"
                              title="แสดงรายการบาร์โค้ด"
                              @click.prevent="onShowLocalBarcodeClick(item)"
                            >
                              <i class="text-info la la-list"></i>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div class="kt-section kt-section--first" v-if="shopReturnItems && shopReturnItems.length > 0">
              <h3 class="kt-section__title text-info"><i class="la la-reply-all"></i> รายการสินค้า/ทรัพย์สิน ที่รับคืนจากร้านค้า:</h3>
              <div class="kt-section__body">
                <div class="row">
                  <div class="col-sm-12 table-responsive">
                    <table class="table table-sm table-striped table-bordered table-hover table-checkable">
                      <thead>
                        <tr>
                          <th class="text-center" width="5%">ลำดับ</th>
                          <th class="text-center" width="25%">
                            สินค้า/ทรัพย์สิน
                          </th>
                          <th class="text-center">รายละเอียด</th>
                          <th class="text-center" width="15%">จำนวน</th>
                          <th class="text-center" width="10%">หน่วย</th>
                          <th class="text-center" width="8%">คำสั่ง</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, i) in shopReturnItems" :key="'shop-return-item-' + i">
                          <td class="text-center">{{ i + 1 }}</td>
                          <td class="form-group">{{ item.materialName }} [{{ item.materialCode }}]</td>
                          <td class="form-group">{{ item.description }}</td>
                          <td class="form-group text-right">
                            {{ item.quantity | currency("", 0) }}
                          </td>
                          <td class="text-center">{{ item.baseUnit }}</td>
                          <td class="text-center">
                            <button
                              v-if="!isEditable"
                              type="button"
                              class="btn btn-outline-hover-info btn-elevate btn-circle btn-icon"
                              title="แสดงรายการบาร์โค้ด"
                              @click.prevent="onShowLocalBarcodeClick(item)"
                            >
                              <i class="text-info la la-list"></i>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xl-12">
                <div class="form-group">
                  <label>หมายเหตุ:</label>
                  <textarea :readonly="!isEditable" placeholder="หมายเหตุ" class="form-control" v-model="remark" rows="5" maxlength="1000"></textarea>
                  <span class="form-text text-muted text-right">{{ (remark || '').length }} / 1000 อักษร</span>
                </div>
              </div>
            </div>

            <div class="row" v-if="signatureFileUrl">
              <div class="col-sm-12">
                <div class="form-group">
                  <label class="label-required">ลายเซ็นต์ผู้รับสินค้า/ทรัพย์สิน: </label>
                  <br />
                  <img style="max-width: 300px;" v-bind:src="signatureFileUrl" />
                </div>
              </div>
            </div>

            <div class="row" v-if="evidenceRequired && evidenceCanPickFromGallery">
              <div class="col-sm-12">
                <button type="button" class="btn m-btn--pill btn-info btn-block uploader-btn col-xl-2" id="uploader-evidence">
                  <i class="flaticon-upload-1"></i> รูปภาพหลักฐาน
                </button>
                <span class="text-sm text-danger" style="font-size:small"> (เลือกได้เฉพาะสกุลไฟล์ JPG, JPEG, PNG ขนาดไม่เกิน 10Mb.)</span>
              </div>
            </div>

            <div class="row" v-if="evidenceFileName && evidenceRefCode">
              <div class="col-sm-12">
                <div class="form-group">
                  <label class="label-required">รูปภาพหลักฐานการส่งมอบ (ยังไม่บันทึก):</label>
                  <br />
                  <img style="max-width: 600px;" v-bind:src="'/Plupload/' + evidenceRefCode + '/' + encodeURIComponent(evidenceFileName)" />
                </div>
              </div>
            </div>

            <div class="row" v-if="evidenceFileUrl">
              <div class="col-sm-12">
                <div class="form-group">
                  <label class="label-required">รูปภาพหลักฐานการส่งมอบ:</label>
                  <br />
                  <img style="max-width: 600px;" v-bind:src="evidenceFileUrl" />
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="kt-portlet__foot">
          <div class="row">
            <div class="col-lg-12 kt-align-right">
              <button type="button" @click.prevent="$router.go(-1)" class="btn btn-sm btn-clean kt-margin-r-10">
                <i class="la la-arrow-left"></i>
                <span class="kt-hidden-mobile">กลับ</span>
              </button>
              <button v-if="isEditable" type="button" @click.prevent="formSubmit" class="btn btn-sm btn-primary kt-margin-r-10">
                <i class="la la-save"></i>
                <span class="kt-hidden-mobile">บันทึกข้อมูล</span>
              </button>
              <button type="button" @click.prevent="commit" class="btn btn-sm btn-success kt-margin-r-10" v-if="canCommit()">
                <i class="fa fa-archive"></i>
                <span class="kt-hidden-mobile">ปิดใบงาน</span>
              </button>
              <button type="button" @click.prevent="approvalProcess(true)" class="btn btn-sm btn-success kt-margin-r-10" v-if="hasApproveProcess">
                <i class="fa fa-check"></i>
                <span class="kt-hidden-mobile">อนุมัติ</span>
              </button>
              <button type="button" @click.prevent="approvalProcess(false)" class="btn btn-sm btn-danger" v-if="hasApproveProcess">
                <i class="fa fa-times"></i>
                <span class="kt-hidden-mobile">ไม่อนุมัติ</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div ref="barcodeModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="modelSingle" aria-hidden="true">
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">รายการบาร์โค้ด</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="kt-portlet__body">
              <div class="kt-section kt-section--first">
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <label>สินค้า/ทรัพย์สิน:</label>
                      <span class="form-control">{{ selectedItem.materialName }} [{{ selectedItem.materialCode }}]</span>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group" style="display: none;" ref="barcodeTableWrapper">
                      <!--begin: Datatable -->
                      <table class="table-sm table-striped table-bordered table-hover" ref="barcodeTable">
                        <thead>
                          <tr>
                            <th class="all text-center">ลำดับ</th>
                            <th class="all">BARCODE</th>
                            <th class="all">รหัสทรัพย์สิน(เบียร์สด)</th>
                            <th class="all">ผู้ถือครองก่อนหน้า</th>
                            <th class="all">ผู้ดูแล(ตัวแทนฯ)</th>
                            <th class="all">สถานะบาร์โค้ด</th>
                            <th class="all">เวลาสแกน</th>
                            <th class="all">โดย</th>
                            <th class="all">คำสั่ง</th>
                            <th class="none">รายการอะไหล่</th>
                          </tr>
                        </thead>
                      </table>
                    </div>
                    <div class="form-group" ref="barcodeTable2Wrapper">
                      <table class="table-sm table-striped table-bordered table-hover" ref="barcodeTable2">
                        <thead>
                          <tr>
                            <th class="all text-center">ลำดับ</th>
                            <th class="all">BARCODE</th>
                            <th class="all">รหัสทรัพย์สิน(เบียร์สด)</th>
                            <th class="all">เวลาสแกน</th>
                            <th class="all">โดย</th>
                            <th class="all">คำสั่ง</th>
                            <th class="none">รายการอะไหล่</th>
                          </tr>
                        </thead>
                      </table>
                      <!--end: Datatable -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div ref="barcodeLocalModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="modelSingle" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">รายการบาร์โค้ด</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="kt-portlet__body">
              <div class="kt-section kt-section--first">
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <label>สินค้า/ทรัพย์สิน:</label>
                      <span class="form-control">{{ localMaterialName }} [{{ localMaterialCode }}]</span>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <!--begin: Datatable -->
                      <table class="table-sm table-striped table-bordered table-hover" ref="barcodeLocalTable">
                        <thead>
                          <tr>
                            <th class="all text-center">ลำดับ</th>
                            <th class="all">BARCODE</th>
                            <th class="all">รหัสทรัพย์สิน(เบียร์สด)</th>
                            <th class="all">เวลาสแกน</th>
                            <th class="all">โดย</th>
                          </tr>
                        </thead>
                      </table>
                      <!--end: Datatable -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div ref="barcodeScanModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="modelSingle" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">รายการบาร์โค้ดที่เกิดข้อผิดพลาด</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="kt-portlet__body">
              <div class="kt-section kt-section--first">
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <!--begin: Datatable -->
                      <table id="barcodeScanTable" class="table-sm table-striped table-bordered table-hover" ref="barcodeScanTable">
                        <thead>
                          <tr>
                            <th class="all text-center">ลำดับ</th>
                            <th class="all">BARCODE</th>
                            <th class="all">รหัสทรัพย์สิน(เบียร์สด)</th>
                            <th class="all">สถานะ</th>
                          </tr>
                        </thead>
                      </table>
                      <!--end: Datatable -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import plupload from "plupload";
import select2 from "../../Shared/Select2";
import jobItemRow from "./JobItemRow";
import jobRefDocumentRow from "./JobRefDocumentRow";
import jobRefInvoiceRow from "./JobRefInvoiceRow";
import jobRefJobRow from "./JobRefJobRow";

let BarcodeActions = Vue.extend({
  template: `
<div>
  <a v-if="$parent.jobStatus == 'JOB_STATUS_PENDING'" href="#" @click.prevent="remove" class="btn btn-sm btn-clean btn-icon btn-icon-md" title="ลบบาร์โค้ด">
    <i class="fa fa-trash-alt kt-font-danger"></i>
  </a>
</div>
`,
  methods: {
    remove() {
      let self = this;

      Swal.fire({
        title: "คำสั่งลบข้อมูลบาร์โค้ด",
        type: "warning",
        html: "กรุณายืนยันคำสั่งลบข้อมูลบาร์โค้ด <strong>" + self.data.barcodeNo + "</strong>",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังลบข้อมูล กรุณารอสักครู่...",
          });

          axios
            .post("/Api/Jobs/RemoveBarcode", {
              jobId: self.$parent.$route.params.id,
              barcodes: [self.data.barcodeNo],
            })
            .then(function(response) {
              if (response.data.status) {
                $(self.$parent.$refs.barcodeTable)
                  .DataTable()
                  .ajax.reload(null, true);
                $(self.$parent.$refs.barcodeTable2)
                  .DataTable()
                  .ajax.reload(null, true);

                var job = response.data.data.job;
                for (let i = 0; i < job.items.length; i++) {
                  const item = job.items[i];
                  for (let j = 0; j < self.$parent.items.length; j++) {
                    const oldItem = self.$parent.items[j];
                    if (oldItem.jobItemId == item.itemId) {
                      oldItem.checkedQuantity = item.checkedQuantity;
                      oldItem.quantity = item.quantity;
                      break;
                    }
                  }
                }

                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
  },
});

export default {
  components: {
    select2,
    jobItemRow,
    jobRefDocumentRow,
    jobRefInvoiceRow,
    jobRefJobRow,
  },
  data() {
    var self = this;
      return {
      isSubAgentOrShop: false,
      isEditable: true,
      isEditableTypePICKUP:true,
      isEdit: false,
      isTransitInit: false,
      barcodeForm: {
        barcode: "",
        isLoading: false,
      },
      uuid: "",
      uuid_attach: "",
      uuid_evidence: "",
      noUseSML: false,
      doUploader: null,
      fileUploader: null,
      selectedItem: {},
      findType: true,
      scanBarcodeMessage: "",
      scanBarcodeResults: [],
      originData: null,
      originLocationIdOptions: {
        placeholder: "กรุณาเลือกสถานที่ต้นทาง (Origin)",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2JobLocation",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };

            query = self.genOriginQuery(query);

            return JSON.stringify(query);
          },
          processResults: function(data, params) {
             return {
                  results: data.results,
                  pagination: {
                    more: data.more,
                  },
                };
            
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
        templateResult: function(data) {
          if (!data.id || !data.data) return data.text;

          if (data.data.locationType == "PLANT") {
            return data.text;
          } else if (data.data.locationType == "AGENT") {
            var $container = $(
              "<div class='select2-result-repository clearfix'>" +
                "<div class='select2-result-repository__meta'>" +
                "<div class='select2-result-repository__title'></div>" +
                "<div class='select2-result-repository__description'></div>" +
                "</div>" +
                "</div>"
            );

            $container.find(".select2-result-repository__title").text(data.text);

            if (data.data.agentType != "HEAD_OFFICE") {
              $container.find(".select2-result-repository__description").html("SAP Code: " + data.id + "<br />HQ: " + data.data.headOffice);
            } else {
              $container.find(".select2-result-repository__description").text("SAP Code: " + data.id + " สำนักงานใหญ่");
            }

            return $container;
          } else {
            return data.text;
          }
        },
        language: {
          noResults: function() {
            return "ไม่พบข้อมูลสถานที่ต้นทาง (Origin)";
          },
        },
      },
      destinationData: null,
      destinationLocationIdOptions: {
        placeholder: "กรุณาเลือกสถานที่ปลายทาง (Destination)",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2JobLocation",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };

            query = self.genDestinationQuery(query);

            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
        templateResult: function(data) {
          if (!data.id || !data.data) return data.text;

          if (data.data.locationType == "PLANT") {
            return data.text;
          } else if (data.data.locationType == "AGENT") {
            var $container = $(
              "<div class='select2-result-repository clearfix'>" +
                "<div class='select2-result-repository__meta'>" +
                "<div class='select2-result-repository__title'></div>" +
                "<div class='select2-result-repository__description'></div>" +
                "</div>" +
                "</div>"
            );

            $container.find(".select2-result-repository__title").text(data.text);

            if (data.data.agentType != "HEAD_OFFICE") {
              $container.find(".select2-result-repository__description").html("SAP Code: " + data.id + "<br />HQ: " + data.data.headOffice);
            } else {
              $container.find(".select2-result-repository__description").text("SAP Code: " + data.id + " สำนักงานใหญ่");
            }

            return $container;
          } else {
            return data.text;
          }
        },
        language: {
          noResults: function() {
            if (self.$route.meta.jobType == "EXCHANGE") {
              let originEl = self.$refs.originLocationId.$el;
              let selectedData = $(originEl).select2("data");
              if (selectedData.length == 0) {
                return "กรุณาเลือกสถานที่ต้นทาง (Origin) ก่อนเลือกสถานที่ปลายทาง (Destination)";
              }
            }
            return "ไม่พบข้อมูลสถานที่ปลายทาง (Destination)";
          },
        },
      },
      finishedProductCodeOptions: {
        placeholder: "กรุณาเลือกสินค้าที่ต้องการผลิต",
        allowClear: true,
        ajax: {
          delay: 300,
          url: "/Api/Product/Select2Product",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              // สินค้าสำเร็จรูป
              productGroupId: 14,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
        language: {
          noResults: function() {
            return "ไม่พบข้อมูลสินค้า";
          },
        },
      },
      transportOptions: {
        placeholder: "กรุณาเลือกรถสำหรับขนส่งสินค้า/ทรัพย์สิน",
        allowClear: true,
        ajax: {
          url: "/Api/Transport/Select2Transport",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              showVendorTransport: false,
              agentCodes: [],
              isShowAll: true,
            };

            if (self.$route.meta.jobType == "TRANSFER_TO_AGENT" || self.$route.meta.jobType == "BORROW") {
              query.showVendorTransport = true;

              if (self.destinationData && self.destinationData.data.locationType == "AGENT") {
                query.agentCodes.push(self.destinationLocationId);
              }

              if (self.refDocuments) {
                self.refDocuments.forEach((doc) => {
                  query.agentCodes.push(doc.shipTo);
                });
              }
            } else if (self.$route.meta.jobType == "RETURN") {
              query.showVendorTransport = true;
              query.agentCodes.push(self.originLocationId);
            } else if (
              self.$route.meta.jobType == "RETRIEVE_ITEM" &&
              self.originData.data.locationType == "AGENT" &&
              self.destinationData.data.locationType == "PLANT"
            ) {
              query.showVendorTransport = true;
              query.agentCodes.push(self.destinationLocationId);
            } else if (self.$route.meta.jobType == "EXCHANGE") {
              let originEl = self.$refs.originLocationId.$el;
              let selectedData = $(originEl).select2("data");
              if (selectedData.length > 0) {
                let origin = selectedData[0];
                if (origin.data.locationType == "PLANT") {
                  query.showVendorTransport = true;
                } else if (origin.data.locationType == "AGENT") {
                  query.agentCodes.push(self.originLocationId);
                  query.agentCodes.push(self.destinationLocationId);
                }
              }
            } else if (self.$route.meta.jobType == "RETURN_ADHOC") {
              query.showVendorTransport = true;
              query.showAllAgentTransport = true;
            }
            // query.agentCodes.push();

            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
        language: {
          noResults: function() {
            if (self.$route.meta.jobType == "RETURN") {
              if (!self.originData) {
                return "กรุณาเลือกสถานที่ต้นทาง (Origin) ก่อนเลือกข้อมูลรถสำหรับขนส่งสินค้า/ทรัพย์สิน";
              }
            }

            return "ไม่พบข้อมูลรถสำหรับขนส่งสินค้า/ทรัพย์สิน";
          },
        },
      },
      shopCodeOptions: {
        placeholder: "กรุณาเลือกร้านค้า",
        allowClear: true,
        ajax: {
          url: "/Api/Shop/Select2Shop",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };

            query.agentCodes = [self.originLocationId];

            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
        templateResult: function(data) {
          return data.text;
        },
        language: {
          noResults: function() {
            return "ไม่พบข้อมูลร้านค้า";
          },
        },
      },
      userIds: [],
      userIdsOptions: {
        placeholder: "เลือก User",
        allowClear: true,
        ajax: {
          url: "/Api/Users/Select2JobUser",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };

            query = self.genUserQuery(query);
            
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      // Form Data
      jobNumber: null,
      jobDate: null,
      jobTypeName: null,
      jobStatus: "JOB_STATUS_WAITING",
      fromJobNumber: null,
      originLocationId: null,
      destinationLocationId: null,
      finishedProductCode: null,
      remark: null,
      items: [],
      shopItems: [],
      shopReturnItems: [],
      ItemHistory: [],
      pickupItems: [],
      pickupReturnItems: [],
      refDocuments: [],
      refInvoices: [],
      refJobs: [],
      uploadFiles: [],
      parentJobType: null,
      parentJobTypeName: null,
      showItems: true,
      transitId: null,
      transitId2: null,
      pickupAtOrigin: false,
      localBarcodes: [],
      localMaterialName: null,
      localMaterialCode: null,
      hasApproveProcess: false,
      signatureGridFSId: null,
      signatureFileUrl: null,
      signatureFileInfoId: null,
      evidenceGridFSId: null,
      evidenceFileUrl: null,
      evidenceFileInfoId: null,
      evidenceRequired: false,
      evidenceCanPickFromGallery: false,
      evidenceRefCode: null,
      evidenceFileName: null,
      productLoan: null,
      isBeerClaimAdmin: true,
      // Job object สำหรับเก็บข้อมูลทั้งหมดจาก API
      job: {
        jobDestinations: [],
        items: []
      },
      // Multi-shop destinations for TRANSFER_TO_MULTI_SHOP
      jobDestinations: [
        {
          _uid: Date.now(), // Unique ID for Vue key binding
          destinationLocationId: null,
          destinationName: '',
          destinationData: null,
          items: []
        }
      ],
      nextDestinationUid: Date.now() + 1, // Counter for generating unique IDs
      hideItems: [
        "RETURN_ADHOC",
        "NEW_SHOP",
        "PM_CHECK",
        "EDIT_NFC",
        "INSPECTIONS_AND_BORROW_PROPERTY",
        "QI_NO_EQUIPMENT",
        "TYPING_BARCODE",
        "QI_LESS_THAN_61",
        "EDIT_SHOP",
      ],
      isPreviousBalance: false
    };
  },
  methods: { 
    isShowOnJobTypes(types) {
      var self = this; 
  

      if (typeof types == "object" && Array.isArray(types)) {
        return (
          $.grep(types, function(ele, idx) {
            if (typeof ele == "object" && Array.isArray(ele)) {
              return ele[0] == self.$route.meta.jobType && self.parentJobType == ele[1];
            } else {
              return ele == self.$route.meta.jobType;
            }
          }).length > 0
        );
      } else {
        return types == self.$route.meta.jobType;
      }

    
    },
    approvalProcess(approve = false) {
      let self = this;

      if (approve && self.uploadFiles.length == 0) {
        // if (self.$route.meta.jobType == "DESTROY") {
        //   let hasBarcode = false;
        //   for (let i = 0; i < self.items.length; i++) {
        //     const item = self.items[i];
        //     hasBarcode = hasBarcode || item.hasBarcode;
        //   }

        //   if (hasBarcode) {
        //     Swal.fire(
        //       "เกิดข้อผิดพลาด",
        //       "กรุณาอัพโหลดไฟล์เอกสารก่อนอนุมัติใบงาน",
        //       "error"
        //     );
        //     return;
        //   }
        // } else {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาอัพโหลดไฟล์เอกสารก่อนอนุมัติใบงาน", "error");
        return;
        // }
      }

      const apprSwal = Swal.mixin({
        customClass: {
          confirmButton: approve ? "btn btn-success" : "btn btn-danger",
          cancelButton: "btn btn-secondary",
        },
        buttonsStyling: false,
      });

      apprSwal
        .fire({
          title: approve ? "คำสั่งอนุมัติ" : "คำสั่งไม่อนุมัติ",
          type: "warning",
          html: "กรุณายืนยัน" + (approve ? "คำสั่งอนุมัติ" : "คำสั่งไม่อนุมัติ") + " <strong>" + self.jobNumber + "</strong>",
          showCancelButton: true,
          confirmButtonText: approve ? "อนุมัติ" : "ไม่อนุมัติ",
          cancelButtonText: "ตรวจสอบ",
        })
        .then((result) => {
          if (result.value) {
            self.approvalProcessJob(approve, false);
          }
        });
    },
    approvalProcessJob(approve = false, force = false) {
      var self = this;
      let router = this.$router;

      var data = {
        jobId: self.$route.params.id,
        force: force,
        approve: approve,
        attachments: self.uploadFiles,
      };

      // -- Begin Commit Job
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
      });

      axios
        .post("/Api/Jobs/Commit", data)
        .then(function(response) {
          if (response.data.status) {
            Swal.fire("สำเร็จ", response.data.message, "success").then(function() {
              // self.$parent.reloadDataTable();
              router.push({ name: "JobSearch" });
            });
          } else {
            let msg = response.data.message;
            if (response.data.errors) {
              let html = "";
              for (var key in response.data.errors) {
                if (response.data.errors.hasOwnProperty(key)) {
                  var err = response.data.errors[key];
                  html += "<li>" + err[1] + "</li>";
                }
              }

              if (html) {
                msg +=
                  "<div class='text-left mt-3'>หากคุณต้องการปิดใบงานนี้ กรุณายืนยันอีกครั้งโดยคลิกปุ่ม <strong>ฉันต้องการปิดใบงานนี้</strong><br /><br />สาเหตุ: <ul>" +
                  html +
                  "</ul></div>";
              }
            }

            Swal.fire({
              title: "เกิดข้อผิดพลาด",
              html: msg,
              type: "error",
              showCancelButton: true,
              confirmButtonText: "<i class='fa fa-archive'></i> ฉันต้องการปิดใบงานนี้",
              cancelButtonText: "ตรวจสอบข้อมูล",
            }).then((result) => {
              if (result.value) {
                self.approvalProcessJob(true, true);
              }
            });
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
      // -- End Commit Job
    },
    submitBarcode() {
      var self = this;
      if (self.barcodeForm.barcode) {
        var data = {
          jobId: self.$route.params.id,
          barcode: self.barcodeForm.barcode,
        };

        KTApp.blockPage({
          opacity: 0.05,
          message: "กำลังสแกนบาร์โค้ด กรุณารอสักครู่...",
        });

        self.scanBarcodeMessage = "";
        self.scanBarcodeResults = [];

        // -- Begin Submit Barcode
        self.barcodeForm.isLoading = true;
        axios
          .post("/Api/Jobs/ScanBarcode", data)
          .then(function(response) {
            toastr.options = {
              closeButton: true,
              debug: false,
              newestOnTop: false,
              progressBar: false,
              positionClass: "toast-bottom-right",
              preventDuplicates: false,
              onclick: null,
              showDuration: "300",
              hideDuration: "1000",
              timeOut: "5000",
              extendedTimeOut: "5000",
              showEasing: "swing",
              hideEasing: "linear",
              showMethod: "fadeIn",
              hideMethod: "fadeOut",
            };

            let data = response.data;
            self.barcodeForm.barcode = "";
            if (data.status) {
              var job = data.data.job;
              self.jobStatus = job.jobStatusCode;
              self.isEditable = false;
              for (let i = 0; i < job.items.length; i++) {
                const item = job.items[i];
                for (let j = 0; j < self.items.length; j++) {
                  const oldItem = self.items[j];
                  if (oldItem.jobItemId == item.itemId) {
                    oldItem.checkedQuantity = item.checkedQuantity;
                    oldItem.quantity = item.quantity;
                    break;
                  }
                }
              }
              toastr.success(data.message);
            } else {
              toastr.error(data.message);
            }

            self.scanBarcodeMessage = data.message;
            self.scanBarcodeResults = data.data.barcodeResults;

            let table = $(self.$refs.barcodeScanTable).DataTable();
            table.clear().draw();
            table.rows.add(self.scanBarcodeResults).draw();
            // });
          })
          .catch(function(error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          })
          .then(function() {
            self.barcodeForm.isLoading = false;
            KTApp.unblockPage();
          });
        // -- End Submit Barcode
      }
    },
    commit(e) {
      e.preventDefault();

      let self = this;

      if (
        !$(self.$refs.jobForm)
          .validate()
          .form()
      ) {
        return false;
      }

      if (self.evidenceRequired && self.evidenceCanPickFromGallery && !self.evidenceFileUrl && (!self.evidenceFileName || !self.evidenceRefCode)) {
        Swal.fire({
          title: "เกิดข้อผิดพลาด",
          html: "กรุณาอัพโหลดรูปภาพหลักฐาน",
          type: "error",
          confirmButtonText: "อัพโหลด",
        });
        return;
      }

      Swal.fire({
        title: "คำสั่งปิดใบงาน",
        type: "warning",
        html: "กรุณายืนยันคำสั่งปิดใบงาน <strong>" + self.jobNumber + "</strong>",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.value) {
          self.commitJob();
        }
      });
    },
    commitJob: function(force = false) {
      var self = this;
      let router = this.$router;

      var data = {
        jobId: self.$route.params.id,
        force: force,
        shopItems: [],
        evidenceFileName: self.evidenceFileName,
        evidenceRefCode: self.evidenceRefCode,
        evidenceFileInfoId: self.evidenceFileUrl,
        evidenceFileUrl: self.evidenceFileUrl,
        evidenceGridFSId: self.evidenceGridFSId,
      };

      for (let i = 0; i < self.shopItems.length; i++) {
        const shopItem = self.shopItems[i];
        data.shopItems.push({
          signatureGridFSId: shopItem.signatureGridFSId,
          signatureFileUrl: shopItem.signatureFileUrl,
          signatureFileInfoId: shopItem.signatureFileInfoId,
          shopName: shopItem.shopName,
          shopCode: shopItem.shopCode,
          smlBillNumber: shopItem.smlBillNumber,
          // ส่ง id ของ barcode ในร้านนี้ไปด้วย ให้ backend match ด้วย id แทน shopName/signatureFileInfoId
          jobItemBarcodeIds: (shopItem.items || []).reduce(function(ids, item) {
            return ids.concat((item.barcodes || []).map(function(barcode) {
              return barcode.jobItemBarcodeId;
            }));
          }, []),
        });
      }

      // -- Begin Commit Job
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
      });
      axios
        .post("/Api/Jobs/Commit", data)
        .then(function(response) {
          if (response.data.status) {
            Swal.fire("สำเร็จ", response.data.message, "success").then(function() {
              // self.$parent.reloadDataTable();
              router.push({ name: "JobSearch" });
            });
          } else {
            let msg = response.data.message;
            if (response.data.errors) {
              let html = "";
              for (var key in response.data.errors) {
                if (response.data.errors.hasOwnProperty(key)) {
                  var err = response.data.errors[key];
                  html += "<li>" + err[1] + "</li>";
                }
              }

              if (html) {
                msg +=
                  "<div class='text-left mt-3'>หากคุณต้องการปิดใบงานนี้ กรุณายืนยันอีกครั้งโดยคลิกปุ่ม <strong>ฉันต้องการปิดใบงานนี้</strong><br /><br />สาเหตุ: <ul>" +
                  html +
                  "</ul></div>";
              }
            }

            let start = msg.indexOf("||");
            let end = msg.lastIndexOf("||");
            if(start >= 0){
              let str = msg.substr((start+2), (end-start-2));
              let oldStr = msg.substr((start), (end-start+2));
              // console.log(start);
              // console.log(end);
              // console.log(str);
              // console.log(oldStr);
              let repl = "<strong class='text-danger'>"+str+"</strong>";
              msg = msg.replace(oldStr, repl);
            }

            Swal.fire({
              title: "เกิดข้อผิดพลาด",
              html: msg,
              type: "error",
              showCancelButton: true,
              confirmButtonText: "<i class='fa fa-archive'></i> ฉันต้องการปิดใบงานนี้",
              cancelButtonText: "ตรวจสอบข้อมูล",
            }).then((result) => {
              if (result.value) {
                self.commitJob(true);
              }
            });
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
      // -- End Commit Job
    },
    formSubmit(e) {
      e.preventDefault();

      let self = this;
      let router = this.$router;

      if (
        !$(self.$refs.jobForm)
          .validate()
          .form()
      ) {
        return false;
      }

      if (self.noUseSML === true) {
        self.refInvoices = [];
      }
      
      let job = {
        jobType: self.$route.meta.jobType,
        jobDate: self.jobDate.format("DD/MM/YYYY"),
        originLocationId: self.originLocationId,
        originLocationType: self.originData ? self.originData.data.locationType : null,
        destinationLocationId: self.destinationLocationId,
        destinationLocationType: self.destinationData ? self.destinationData.data.locationType : null,
        finishedProductCode: self.finishedProductCode,
        remark: self.remark,
        items: self.items,
        refDocuments: self.refDocuments,
        refInvoices: self.refInvoices,
        attachments: self.uploadFiles,
        pickupAtOrigin: self.pickupAtOrigin,
        transitId: self.transitId,
        noUseSML: self.noUseSML,
        evidenceFileInfoId: self.evidenceFileUrl,
        evidenceFileUrl: self.evidenceFileUrl,
        evidenceGridFSId: self.evidenceGridFSId,
        assignToUsers: self.userIds,
        isPreviousBalance: self.isPreviousBalance
      };

      // Add jobDestinations for TRANSFER_TO_MULTI_SHOP
      if (self.$route.meta.jobType == "TRANSFER_TO_MULTI_SHOP") {
          job.jobDestinations = self.jobDestinations;
      }

      if (
        self.isShowOnJobTypes(["REPAIR_SUPPLIER", "RETURN_SUPPLIER"]) ||
        (self.$route.meta.jobType == "DESTROY" && (self.jobStatus == "JOB_STATUS_REQUEST_APPROVAL" || self.jobStatus == "JOB_STATUS_SUCCESS"))
      ) {
        // ไฟล์เอกสาร
        if (self.uploadFiles == null || self.uploadFiles.length == 0) {
          Swal.fire("เกิดข้อผิดพลาด", "ใบงานจะต้องมี ไฟล์เอกสาร อย่างน้อย 1 รายการ", "error");
          return false;
        }
      } else if (self.isShowOnJobTypes(["TRANSFER_TO_AGENT", ["RETRIEVE_ITEM", "JOB_TYPE_TRANSFER_TO_AGENT"]])) {
        // ใบส่งสินค้า (Delivery Order)
        if (self.refDocuments == null || self.refDocuments.length == 0) {
          Swal.fire("เกิดข้อผิดพลาด", "ใบงานจะต้องมี ใบส่งสินค้า (Delivery Order) อย่างน้อย 1 รายการ", "error");
          return false;
        }
      } else if (self.isShowOnJobTypes(["TRANSFER_TO_SHOP", ["RETRIEVE_ITEM", "JOB_TYPE_TRANSFER_TO_SHOP"]])) {
        // บิลขาย (Invoice)
        if (
          (self.refInvoices == null || self.refInvoices.length == 0) &&
          self.$route.meta.jobType == "TRANSFER_TO_SHOP" &&
          self.originData &&
          self.originData.data.locationType == "AGENT" &&
          !self.originData.data.noSML &&
          !self.noUseSML
        ) {
          Swal.fire("เกิดข้อผิดพลาด", "ใบงานจะต้องมี บิลขาย (Invoice) อย่างน้อย 1 รายการ", "error");
          return false;
        }
      } else if (self.showRefInvoices) {
        // ใบเบิกสินค้า
        if (self.refInvoices == null || self.refInvoices.length == 0) {
          Swal.fire(
            "เกิดข้อผิดพลาด",
            this.$route.meta.jobType == "PICKUP" ? "ใบงานจะต้องมี ใบโอนสินค้า อย่างน้อย 1 รายการ" : "ใบงานจะต้องมี ใบเบิกสินค้า อย่างน้อย 1 รายการ",
            "error"
          );
          return false;
        }
      }

      // Validation for TRANSFER_TO_MULTI_SHOP
      if (self.$route.meta.jobType == "TRANSFER_TO_MULTI_SHOP") {
        if (!self.jobDestinations || self.jobDestinations.length == 0) {
          Swal.fire("เกิดข้อผิดพลาด", "ใบงานจะต้องมี สถานที่ปลายทาง อย่างน้อย 1 รายการ", "error");
          return false;
        }
        
        // Check each destination
        for (let i = 0; i < self.jobDestinations.length; i++) {
          const dest = self.jobDestinations[i];
          
          if (!dest.destinationLocationId) {
            Swal.fire("เกิดข้อผิดพลาด", `กรุณาเลือกสถานที่ปลายทาง (Destination) สำหรับร้านค้าลำดับที่ ${i + 1}`, "error");
            return false;
          }
          
          if (!dest.items || dest.items.length == 0) {
            Swal.fire("เกิดข้อผิดพลาด", `กรุณาเพิ่มรายการสินค้า/ทรัพย์สิน สำหรับร้านค้าลำดับที่ ${i + 1}`, "error");
            return false;
          }
        }
      }

      if (job.items.length == 0 && self.$route.meta.jobType != "RETURN_ADHOC" && self.$route.meta.jobType != "TRANSFER_TO_MULTI_SHOP") {
        Swal.fire("เกิดข้อผิดพลาด", "ใบงานจะต้องมี รายการสินค้า/ทรัพย์สิน อย่างน้อย 1 รายการ", "error");
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
      });

      if (self.isEdit) {
        job.jobId = self.$route.params.id;
      }

      axios({
        method: self.isEdit ? "put" : "post",
        url: "/Api/Jobs",
        data: {
          job: job,
          evidenceFileName: self.evidenceFileName,
          evidenceRefCode: self.evidenceRefCode,
        },
      })
        .then(function(response) {
          if (response.data.status) {
            Swal.fire("สำเร็จ", response.data.message, "success").then(function() {
              // self.$parent.reloadDataTable();
              router.push({ name: "JobSearch" });
            });
          } else {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    },
    onAddRefDocumentClick(e) {
      this.refDocuments.push({
        id: null,
        documentNumber: null,
        documentDate: null,
        items: [],
      });
    },
    onAddRefInvoiceClick(e) {
      this.refInvoices.push({
        id: null,
        documentNumber: null,
        documentDate: null,
        isPreviousBalance: false,
        items: [],
      });
    },
    onRemoveRefDocumentClick(index, delItem) {
      this.refDocuments.splice(index, 1);
    },
    onRemoveRefInvoiceClick(index, delItem) {
      this.refInvoices.splice(index, 1);
    },
    onRemoveUploadFileClick(index, delItem) {
      this.uploadFiles.splice(index, 1);
    },
    onAddItemClick(e) {
      this.items.push({
        materialCode: null,
        materialName: null,
        description: null,
        quantity: 0,
        checkedQuantity: 0,
        unitName: null,
        barcodeStatus : null
      });
    },
    onCalculateItemClick($event, msg = "คุณต้องการคำนวณรายการสินค้า/ทรัพย์สินหรือไม่? ระบบจะล้างข้อมูลในรายการสินค้า/ทรัพย์สินออกทั้งหมด") {
      let self = this;
      let newItems = [];

      Swal.fire({
        title: "คำนวณรายการสินค้า/ทรัพย์สิน",
        type: "warning",
        html: msg,
        showCancelButton: true,
        confirmButtonText: '<i class="fa fa-calculator"></i> คำนวณใหม่',
        cancelButtonText: "ไม่ต้องการ",
      }).then((result) => {
        if (result.value) {
          self.refDocuments.forEach((doc) => {
            doc.items.forEach((dItem) => {
              if (
                dItem.productGroupId == 2 ||
                dItem.productGroupId == 14 ||
                (dItem.productGroupId == 1 && dItem.productTypeId != 4 && dItem.productTypeId != 5)
              ) {
                // 1	เครื่องและอุปกรณ์เบียร์สด
                // 2	พรีเมี่ยมสื่อ
                // 14	สินค้าสำเร็จรูป
                // Add Filter Here
                let exists = $.grep(newItems, function(obj, idx) {
                  return obj.materialCode == dItem.materialCode;
                });

                if (exists.length > 0) {
                  exists[0].quantity += dItem.quantity;
                } else {
                  newItems.push({
                    materialCode: dItem.materialCode,
                    materialName: dItem.materialName,
                    description: null,
                    quantity: dItem.quantity,
                    checkedQuantity: 0,
                    unitName: dItem.salesUnit,
                    hasBarcode: dItem.hasBarcode,
                    selectedMaterialCodeData: {
                      id: dItem.materialCode,
                      text: dItem.materialName + " [" + dItem.materialCode + "]",
                      data: {
                        baseUnit: dItem.salesUnit,
                        materialCode: dItem.materialCode,
                        hasBarcode: dItem.hasBarcode,
                      },
                    },
                  });
                }
              }
            });
          });

          self.refInvoices.forEach((doc) => {
            doc.items.forEach((dItem) => {
              if (
                (self.$route.meta.jobType == "TRANSFER_TO_SHOP" &&
                  (dItem.productGroupId == 2 ||
                    dItem.productGroupId == 14 ||
                    (dItem.productGroupId == 1 && dItem.productTypeId != 4 && dItem.productTypeId != 5))) ||
                (self.$route.meta.jobType == "PICKUP" && (dItem.productGroupId == 1 && (dItem.productTypeId == 4 || dItem.productTypeId == 5))) ||
                (self.$route.meta.jobType != "TRANSFER_TO_SHOP" && self.$route.meta.jobType != "PICKUP")
              ) {
                // 1	เครื่องและอุปกรณ์เบียร์สด
                // 2	พรีเมี่ยมสื่อ
                // 14	สินค้าสำเร็จรูป
                // Add Filter Here
                let exists = $.grep(newItems, function(obj, idx) {
                  return obj.materialCode == dItem.materialCode;
                });

                if (exists.length > 0) {
                  exists[0].quantity += dItem.quantity;
                } else {
                  // เพิ่มใหม่เฉพาะ invoice ที่ไม่ยกยอด
                  if(doc.isPreviousBalance == false) {
                    newItems.push({
                      materialCode: dItem.materialCode,
                      materialName: dItem.materialName,
                      description: null,
                      quantity: dItem.quantity,
                      checkedQuantity: 0,
                      unitName: dItem.salesUnit,
                      hasBarcode: dItem.hasBarcode,
                      selectedMaterialCodeData: {
                        id: dItem.materialCode,
                        text: dItem.materialName + " [" + dItem.materialCode + "]",
                        data: {
                          baseUnit: dItem.salesUnit,
                          materialCode: dItem.materialCode,
                          hasBarcode: dItem.hasBarcode,
                        },
                      },
                    });
                  }
                }
              }
            });
          });
          
          // ลบเฉพาะ items ที่ไม่ได้ scan barcode
          self.items = self.items.filter(item => item.checkedQuantity > 0);
          // for (let i = 0; i < self.items.length; i++) {
          //   if(self.items[i].checkedQuantity == 0){
          //     self.items.splice(i, 1);
          //   }
          // }
          
          for (let i = 0; i < newItems.length; i++) {
            const item = newItems[i];
            self.items.push(item);
            //หา index ล่าสุดของ items
            let len = self.items.length;
            setTimeout(function() {
              self.$refs.jobItems[len-1].$refs.materialCode.setSelectedData(item.selectedMaterialCodeData);
            }, 50);
          }
        }
      });
    },
    onRemoveItemClick(index, delItem) {
      let self = this;
      let newItems = self.items.slice();
      self.items.splice(0, self.items.length);
      newItems.splice(index, 1);
      for (let i = 0; i < newItems.length; i++) {
        const item = newItems[i];
        self.items.push(item);
        setTimeout(function() {
          self.$refs.jobItems[i].$refs.materialCode.setSelectedData(item.selectedMaterialCodeData);
        }, 50);
      }
    },
    // === Multi-shop destinations methods ===
    onAddDestinationClick() {
      this.jobDestinations.push({
        _uid: this.nextDestinationUid++, // Assign unique ID
        destinationLocationId: null,
        destinationName: '',
        destinationData: null,
        items: []
      });
    },
    onRemoveDestinationClick(destIndex) {
      let self = this;
      Swal.fire({
        title: "คำสั่งลบร้านค้าปลายทาง",
        type: "warning",
        html: "กรุณายืนยันคำสั่งลบร้านค้าปลายทางที่ " + (destIndex + 1),
        showCancelButton: true,
        confirmButtonText: '<i class="fa fa-check"></i> ยืนยัน',
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.value) {
          self.jobDestinations.splice(destIndex, 1);
        }
      });
    },
    onMultiDestinationChange(id, val, data, ref, destIndex) {
      if (data && data.length > 0) {
        const selectedData = data[0];
        const selectedLocationId = selectedData.id;
        const selectedLocationName = selectedData.text;
        const selectedDataObj = selectedData.data || {};
        
        // ใช้ id เป็น uniqueCode เพื่อเช็คซ้ำ
        const uniqueCode = selectedLocationId;
        
        if (!uniqueCode) {
          this.jobDestinations[destIndex].destinationLocationId = selectedLocationId;
          this.jobDestinations[destIndex].destinationName = selectedLocationName;
          this.jobDestinations[destIndex].destinationData = selectedDataObj;
          return;
        }
        
        // รวบรวม id ที่เลือกไว้แล้วทั้งหมด (ยกเว้น index ปัจจุบัน)
        const existingCodes = this.jobDestinations
          .map((dest, index) => {
            if (index !== destIndex && dest.destinationLocationId) {
              return dest.destinationLocationId;
            }
            return null;
          })
          .filter(code => code !== null && code !== undefined);
        
        // เช็คซ้ำ
        if (existingCodes.includes(uniqueCode)) {
          Swal.fire({
            title: "เลือกปลายทางซ้ำ",
            html: `${selectedLocationName} ได้ถูกเพิ่มแล้ว`,
            type: "warning",
            confirmButtonText: "ตกลง"
          }).then(() => {
            // เคลียร์ร้านค้านี้ออก (ใช้ jQuery โดยตรงเหมือนกรณีเปลี่ยนต้นทาง)
            $("#destinationLocationId_" + destIndex)
              .val("")
              .trigger("change");
            
            // Clear data model
            this.jobDestinations[destIndex].destinationLocationId = null;
            this.jobDestinations[destIndex].destinationName = null;
            this.jobDestinations[destIndex].destinationData = null;
          });
          return; // ออกจากฟังก์ชันทันที ไม่ให้ดำเนินการต่อ
        }
        
        // ถ้าไม่ซ้ำ ให้บันทึกข้อมูลปกติ
        this.jobDestinations[destIndex].destinationLocationId = selectedLocationId;
        this.jobDestinations[destIndex].destinationName = selectedLocationName;
        this.jobDestinations[destIndex].destinationData = selectedDataObj;
      }
    },
    formatNumber(value) {
      if (!value && value !== 0) return '-';
      return Number(value).toLocaleString('th-TH');
    },
    onAddMultiShopItemClick(destIndex) {
      this.jobDestinations[destIndex].items.push({
        materialCode: null,
        materialName: null,
        description: null,
        quantity: 0,
        checkedQuantity: 0,
        unitName: null,
      });
    },
    onRemoveMultiShopItemClick(destIndex, itemIndex) {
      let self = this;
      let destination = self.jobDestinations[destIndex];
      let newItems = destination.items.slice();
      destination.items.splice(0, destination.items.length);
      newItems.splice(itemIndex, 1);
      
      for (let i = 0; i < newItems.length; i++) {
        const item = newItems[i];
        destination.items.push(item);
        setTimeout(function() {
          let refKey = 'jobItems_' + destIndex + '_' + i;
          if (self.$refs[refKey] && self.$refs[refKey][0]) {
            self.$refs[refKey][0].$refs.materialCode.setSelectedData(item.selectedMaterialCodeData);
          }
        }, 50);
      }
    },
    // === End Multi-shop destinations methods ===
    onShowBarcodeClick(index, item) {
      this.selectedItem = item;
      if (this.findType === true) {
        this.initializeBarcodeTable();
      } else {
        this.initializeBarcodeTable2();
      }
      $(this.$refs.barcodeModal).modal("show");
    },
    initializeBarcodeTable() {
      const self = this;

      if ($.fn.DataTable.isDataTable(self.$refs.barcodeTable)) {
        $(self.$refs.barcodeTable).DataTable().ajax.reload(null, true);
      } else {
        $(self.$refs.barcodeTable)
        .DataTable({
          responsive: true,
          processing: true,
          serverSide: true,
          searchDelay: 500,
          ajax: {
            url: "/Api/Jobs/FindBarcode",
            type: "post",
            beforeSend: function(request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            },
            data: function(d) {
              d.jobId = self.$route.params.id;
              d.jobItemId = self.selectedItem.jobItemId;
            },
          },
          // DOM Layout settings
          dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
            <'row'<'col-sm-12'tr>>
            <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,
          lengthMenu: [50, 100, 200, 500],
          pageLength: 100,
          language: {
            lengthMenu: "Display _MENU_",
          },
          // Order settings
          order: [[6, "desc"]],
          columns: [
            {
              data: "barcodeNoOld",
              className: "text-center",
              width: "5%",
              sortable: false,
            },
            {
              data: "barcodeNoOld",
              className: "text-center",
              width: "20%",
            },
            {
              data: "departmentMaterialCode",
              className: "text-center",
              width: "20%",
            },
            {
              data: "prevPlantCode",
              className: "text-center",
              width: "15%",
              sortable: false,
              render: function(data, type, full, meta) {
                if (full.prevPlantCode) {
                  return full.prevPlantName;
                } else if (full.prevAgentCode) {
                  return full.prevAgentName + " (ตัวแทนฯ)";
                } else if (full.prevShopCode) {
                  return full.prevShopName + " (ตัวแทนฯย่อย/ร้านค้า)";
                } else if (full.prevSubShopId) {
                  return full.prevSubShopName + " (ร้านค้าของตัวแทนฯย่อย)";
                } else if (full.prevVendorId) {
                  return full.prevVendorName + " (ซัพพลายเออร์)";
                }
                return "";
              },
            },
            {
              data: "rootAgentName",
              className: "text-center",
              width: "15%",
              sortable: false,
            },
            {
              data: "tobeBarcodeStatusName",
              className: "text-center",
              width: "15%",
              sortable: false,
            },
            {
              data: "scanDate",
              className: "text-center",
              width: "15%",
              render: function(data, type, full, meta) {
                return moment(data).format("DD/MM/YYYY HH:mm:ss");
              },
            },
            { data: "scanBy", className: "text-center", width: "15%" },
            {
              data: "barcodeNoOld",
              className: "text-center",
              width: "10%",
              sortable: false,
              render: function(data, type, full, meta) {
                return '<div class="actions"></div>';
              },
            },
            {
              data: "spareParts",
              render: function(data, type, full, meta) {
                var parts = [];
                data.forEach((part) => {
                  if (part.materialCode) {
                    parts.push(part.customSparePartName + " (" + part.materialCode + ")");
                  } else {
                    parts.push(part.customSparePartName);
                  }
                });
                return parts.join(", ");
              },
            },
          ],
          drawCallback: function(settings) {
            // Need to redo the counters if filtered or sorted
            for (var i = 0, iLen = settings.aiDisplay.length; i < iLen; i++) {
              $("td:eq(0)", settings.aoData[settings.aiDisplay[i]].nTr).html(settings._iDisplayStart + i + 1);
              $('[data-toggle="popover"]', settings.aoData[settings.aiDisplay[i]].nTr).popover();
            }
          },
        })
      }

    },
    initializeBarcodeTable2() {
      const self = this;

      if ($.fn.DataTable.isDataTable(self.$refs.barcodeTable2)) {
        $(self.$refs.barcodeTable2).DataTable().ajax.reload(null, true);
      } else {
        $(self.$refs.barcodeTable2)
        .DataTable({
          responsive: true,
          processing: true,
          serverSide: true,
          searchDelay: 500,
          ajax: {
            url: "/Api/Jobs/FindBarcode",
            type: "post",
            beforeSend: function(request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            },
            data: function(d) {
              d.jobId = self.$route.params.id;
              d.jobItemId = self.selectedItem.jobItemId;
            },
          },
          // DOM Layout settings
          dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
            <'row'<'col-sm-12'tr>>
            <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,
          lengthMenu: [50, 100, 200, 500],
          pageLength: 100,
          language: {
            lengthMenu: "Display _MENU_",
          },
          // Order settings
          order: [[1, "desc"]],
          columns: [
            {
              data: "barcodeNoOld",
              className: "text-center",
              width: "5%",
              sortable: false,
            },
            {
              data: "barcodeNoOld",
              className: "text-center",
              width: "20%",
            },
            {
              data: "departmentMaterialCode",
              className: "text-center",
              width: "20%",
            },
            {
              data: "scanDate",
              className: "text-center",
              width: "15%",
              render: function(data, type, full, meta) {
                return moment(data).format("DD/MM/YYYY HH:mm:ss");
              },
            },
            { data: "scanBy", className: "text-center", width: "15%" },
            {
              data: "barcodeNoOld",
              className: "text-center",
              width: "10%",
              sortable: false,
              render: function(data, type, full, meta) {
                return '<div class="actions"></div>';
              },
            },
            {
              data: "spareParts",
              render: function(data, type, full, meta) {
                var parts = [];
                data.forEach((part) => {
                  if (part.materialCode) {
                    parts.push(part.customSparePartName + " (" + part.materialCode + ")");
                  } else {
                    parts.push(part.customSparePartName);
                  }
                });
                return parts.join(", ");
              },
            },
          ],
          drawCallback: function(settings) {
            // Need to redo the counters if filtered or sorted
            for (var i = 0, iLen = settings.aiDisplay.length; i < iLen; i++) {
              $("td:eq(0)", settings.aoData[settings.aiDisplay[i]].nTr).html(settings._iDisplayStart + i + 1);
              $('[data-toggle="popover"]', settings.aoData[settings.aiDisplay[i]].nTr).popover();
            }
          },
        })
      }

    },
    onShowLocalBarcodeClick(item) {
      this.localBarcodes = [];

      let i = 0;
      item.barcodes.forEach((barcode) => {
        this.localBarcodes.push([
          ++i,
          barcode.barcodeNoOld,
          barcode.departmentMaterialCode,
          moment(barcode.scanDate).format("DD/MM/YYYY HH:mm:ss"),
          barcode.scanBy,
        ]);
      });

      this.localMaterialName = item.materialName;
      this.localMaterialCode = item.materialCode;

      let table = $(this.$refs.barcodeLocalTable).DataTable();
      table.clear().draw();
      table.rows.add(this.localBarcodes).draw();

      // this.localBarcodes.forEach(barcode => {
      //   barcode.scanDateText = moment(barcode.scanDate).format(
      //     "DD/MM/YYYY HH:mm:ss"
      //   );
      // });

      $(this.$refs.barcodeLocalModal).modal("show");
    },
    onTransitIdChange(id, value, data, ref) {
      let self = this;
      if (self.isTransitInit && (self.jobStatus == "JOB_STATUS_PENDING" || self.jobStatus == "JOB_STATUS_PICKUP") && value) {
        // -- Begin Submit Barcode
        axios
          .post("/Api/Jobs/SetTransit", {
            jobId: self.$route.params.id,
            transitId: value,
          })
          .then(function(response) {
            toastr.options = {
              closeButton: true,
              debug: false,
              newestOnTop: false,
              progressBar: false,
              positionClass: "toast-bottom-right",
              preventDuplicates: false,
              onclick: null,
              showDuration: "300",
              hideDuration: "1000",
              timeOut: "5000",
              extendedTimeOut: "5000",
              showEasing: "swing",
              hideEasing: "linear",
              showMethod: "fadeIn",
              hideMethod: "fadeOut",
            };

            if (response.data.status) {
              toastr.success(response.data.message);
            } else {
              toastr.error(response.data.message);
            }
          })
          .catch(function(error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          })
          .then(function() {});
        // -- End Submit Barcode
      }
    },
    canCommit() {
      return (
        (this.isShowOnJobTypes("PICKUP") && this.jobStatus == "JOB_STATUS_PICKUP") ||
        (this.evidenceRequired &&
          this.evidenceCanPickFromGallery &&
          (this.jobStatus == "JOB_STATUS_WAITING" || this.jobStatus == "JOB_STATUS_PENDING"))
      );
    },
    initEvidenceUploader() {
      let self = this;
      var uploader = new plupload.Uploader({
        runtimes: "html5",

        browse_button: "uploader-evidence",

        url: "/Components/Plupload?reference=" + self.uuid_evidence,

        max_retries: 5,

        chunk_size: "1mb",

        filters: {
          max_file_size: "10mb",
          mime_types: [
            {
              title: "Image files",
              extensions: "jpg,jpeg,png,JPG,JPEG,PNG",
            },
          ],
        },
        resize: {
          width: 640,
          quality: 100,
        },

        multi_selection: false,

        init: {
          BeforeUpload: function(up) {
            up.settings.url = "/Components/Plupload?reference=" + self.uuid_evidence;
          },
          FilesAdded: function(up, files) {
            Swal.fire({
              title: "ระบบกำลังอัพโหลดรูปภาพหลักฐาน",
              html: "กรุณารอสักครู่...",
              onBeforeOpen: () => {
                Swal.showLoading();
              },
            });

            up.start();
          },

          UploadComplete: function(up, files) {
            self.evidenceRefCode = self.uuid_evidence;
            self.evidenceFileName = files[0].name;
            up.splice();
            self.uuid_evidence = self.$uuid.v1();
            Swal.fire("สำเร็จ", "อัพโหลดรูปภาพหลักฐานสำเร็จ", "success");
          },

          Error: function(up, err) {
            Swal.fire("เกิดข้อผิดพลาด", "File Id " + err.file.id + " Error #" + err.code + ": " + err.message, "error");
          },
        },
      });
      uploader.init();
    },
    initDOUploader() {
      var self = this;
      if (self.doUploader) {
        self.doUploader.destroy();
        self.doUploader = null;
      }
      self.doUploader = new plupload.Uploader({
        runtimes: "html5",

        browse_button: self.$refs.uploadDOBtn, // you can pass in id...
        container: self.$refs.uploadDOBtnContainer, // ... or DOM Element itself

        url: "/Components/Plupload?reference=" + self.uuid,

        max_retries: 5,

        chunk_size: "1mb",

        filters: {
          max_file_size: "10mb",
          mime_types: [{ title: "Excel file", extensions: "xlsx" }],
        },

        // multi_selection: false,

        init: {
          BeforeUpload: function(up) {
            up.settings.url = "/Components/Plupload?reference=" + self.uuid;
          },
          FilesAdded: function(up, files) {
            Swal.fire({
              title: "ระบบกำลังอัพโหลดไฟล์",
              html: "กรุณารอสักครู่...",
              onBeforeOpen: () => {
                Swal.showLoading();
              },
            });

            up.start();
          },

          UploadComplete: function(up, files) {
            // Commit upload files
            axios
              .post("/Api/Jobs/ImportDOExcel", {
                jobId: self.$route.params.id,
                fileNames: $.map(files, function(obj, idx) {
                  return obj.name;
                }),
                reference: self.uuid,
              })
              .then(function(response) {
                let valides = 0;
                let invalides = 0;

                if (response.data.status) {
                  response.data.data.forEach((doc) => {
                    if (
                      $.grep(self.refDocuments, function(curr, idx) {
                        if (curr.documentNumber == doc.documentNumber) {
                          $.extend(curr, doc);
                          return true;
                        }
                        return false;
                      }).length == 0
                    ) {
                      if (self.$route.meta.jobType == "TRANSFER_TO_AGENT") {
                        if (self.originLocationId == doc.plantCode) {
                          valides++;
                          self.refDocuments.push(doc);
                        } else {
                          invalides++;
                        }
                      } else {
                        self.refDocuments.push(doc);
                      }
                    }
                  });

                  if (self.$route.meta.jobType == "TRANSFER_TO_AGENT") {
                    if (valides > 0 && invalides > 0) {
                      self.onCalculateItemClick(
                        null,
                        response.data.message +
                          " <u>แต่พบบางข้อมูลที่สถานที่ต้นทางไม่ตรงตามที่เลือก ซึ่งระบบจะไม่นำเข้าให้</u><br />คุณต้องการคำนวณรายการสินค้า/ทรัพย์สินหรือไม่? ระบบจะล้างข้อมูลในรายการสินค้า/ทรัพย์สินออกทั้งหมด"
                      );
                    } else if (valides > 0 && invalides == 0) {
                      self.onCalculateItemClick(
                        null,
                        response.data.message +
                          "<br />คุณต้องการคำนวณรายการสินค้า/ทรัพย์สินหรือไม่? ระบบจะล้างข้อมูลในรายการสินค้า/ทรัพย์สินออกทั้งหมด"
                      );
                    } else {
                      Swal.fire("เกิดข้อผิดพลาด", "ไฟล์ที่นำเข้าไม่มีข้อมูลใบส่งสินค้า (Delivery Order)", "error");
                    }
                  } else {
                    if (valides > 0) {
                      self.onCalculateItemClick(
                        null,
                        response.data.message +
                          "<br />คุณต้องการคำนวณรายการสินค้า/ทรัพย์สินหรือไม่? ระบบจะล้างข้อมูลในรายการสินค้า/ทรัพย์สินออกทั้งหมด"
                      );
                    } else {
                      Swal.fire("เกิดข้อผิดพลาด", "ไฟล์ที่นำเข้าไม่มีข้อมูลใบส่งสินค้า (Delivery Order)", "error");
                    }
                  }
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
                }
              })
              .catch(function(error) {
                Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
              })
              .then(function() {
                up.splice();
                self.uuid = self.$uuid.v1();
              });
          },

          Error: function(up, err) {
            Swal.fire("เกิดข้อผิดพลาด", "File Id " + err.file.id + " Error #" + err.code + ": " + err.message, "error");
          },
        },
      });
      self.doUploader.init();
    },
    initFileUploader() {
      var self = this;
      if (self.fileUploader) {
        self.fileUploader.destroy();
        self.fileUploader = null;
      }
      self.fileUploader = new plupload.Uploader({
        runtimes: "html5",

        browse_button: self.$refs.uploadFileBtn, // you can pass in id...
        container: self.$refs.uploadFileBtnContainer, // ... or DOM Element itself

        url: "/Components/Plupload?reference=" + self.uuid_attach,

        max_retries: 5,

        chunk_size: "1mb",

        filters: {
          max_file_size: "10mb",
          mime_types: [
            { title: "Image files", extensions: "jpg,gif,png" },
            { title: "Word files", extensions: "docx,doc" },
            { title: "Excel files", extensions: "xlsx,xls" },
            { title: "PDF files", extensions: "pdf" },
          ],
        },

        // multi_selection: false,

        init: {
          BeforeUpload: function(up) {
            up.settings.url = "/Components/Plupload?reference=" + self.uuid_attach;
          },
          FilesAdded: function(up, files) {
            Swal.fire({
              title: "ระบบกำลังอัพโหลดไฟล์",
              html: "กรุณารอสักครู่...",
              onBeforeOpen: () => {
                Swal.showLoading();
              },
            });

            up.start();
          },

          UploadComplete: function(up, files) {
            files.forEach((file) => {
              var blob = file.getNative();
              var fileURL = URL.createObjectURL(blob);
              self.uploadFiles.push({
                fileId: null,
                documentName: file.name,
                fileName: file.name,
                contentType: file.type,
                size: file.size,
                reference: self.uuid_attach,
                fileURL: fileURL,
                isPreview: true
              });
            });
            up.splice();
            Swal.fire("สำเร็จ", "อัพโหลดไฟล์เอกสารสำเร็จ", "success");
          },

          Error: function(up, err) {
            Swal.fire("เกิดข้อผิดพลาด", "File Id " + err.file.id + " Error #" + err.code + ": " + err.message, "error");
          },
        },
      });
      self.fileUploader.init();
    },
    openPreview(fileURL) {
      window.open(fileURL, '_blank');
    },
    onOriginLocationChange(id, val, data, ref) {
      var self = this;
      console.log('[onOriginLocationChange] Called with:', { id, val, data });
      
      self.refDocuments = [];
      self.refInvoices = [];
      self.originData = null;
      self.noUseSML = false;

        //alert(self.$route.meta.jobType);
        //alert(data[0].data.locationType);

        /** 
        Check location for Shop or SubAgent to set default checkbox can pick up a    t origin
        JobType : TRANSFER_TO_SHOP only. 
        **/
        if (self.$route.meta.jobType == "TRANSFER_TO_SHOP" || self.$route.meta.jobType == "JOB_TYPE_TRANSFER_TO_SHOP") {
            if (null != data && data.length > 0) {
                if (data[0].data != null && (data[0].data.locationType == "SHOP" || data[0].data.locationType == "SUBAGENT")) {
                    self.isSubAgentOrShop = true;
                    self.pickupAtOrigin = true;
                } else {
                    self.isSubAgentOrShop = false;
                    //self.pickupAtOrigin = false;
                }
            }
        }

      //AssignToUsers
      if(self.userIds.length > 0) {
        self.userIds = [];
        this.$refs.userIds.setSelectedData([]);
      }

      // Reset Destination (Single destination)
      self.destinationLocationId = null;
      $("#destinationLocationId")
        .val("")
        .trigger("change");

      // Reset JobDestinations (TRANSFER_TO_MULTI_SHOP - Multiple destinations)
      if (self.$route.meta.jobType == "TRANSFER_TO_MULTI_SHOP" || self.$route.meta.jobType == "JOB_TYPE_TRANSFER_TO_MULTI_SHOP") {
        // Clear Select2 UI สำหรับทุก destination
        self.jobDestinations.forEach((dest, index) => {
          $("#destinationLocationId_" + index)
            .val("")
            .trigger("change");
        });
        
        // Reset data model with new unique ID
        self.jobDestinations = [
          {
            _uid: self.nextDestinationUid++, // Assign unique ID
            destinationLocationId: null,
            destinationName: '',
            destinationData: null,
            items: []
          }
        ];
        console.log('[onOriginLocationChange] Reset jobDestinations to 1 empty destination for TRANSFER_TO_MULTI_SHOP');
      }

      if (self.$refs.originLocationId) {
        let originEl = self.$refs.originLocationId.$el;
        let selectedData = $(originEl).select2("data");
        //console.log("selectedData", selectedData[0]);
        if (selectedData.length > 0) {
          self.originData = selectedData[0];
          console.log('[onOriginLocationChange] Set originData:', self.originData);
        }
      }
      if (self.$route.meta.jobType == "RETURN_ADHOC" && self.originData && self.originData.data.locationType == "PLANT") {
        self.findType = true;
        $(self.$refs.barcodeTableWrapper).show();
        $(self.$refs.barcodeTable2Wrapper).hide();
      } else {
        self.findType = false;
        $(self.$refs.barcodeTable2Wrapper).show();
        $(self.$refs.barcodeTableWrapper).hide();
      }
    },
    onDestinationLocationChange(id, val, data, ref) {
      var self = this;
      self.destinationData = null;
      if (self.$refs.destinationLocationId) {
        let destinationEl = self.$refs.destinationLocationId.$el;
        let selectedData = $(destinationEl).select2("data");
        if (selectedData.length > 0) {
          self.destinationData = selectedData[0];
        }
      }
    },
    genOriginQuery(query) {
      var self = this;
      query.jobType = self.$route.meta.jobType;
      
      // ระบุว่าเป็น origin dropdown เฉพาะ TRANSFER_TO_MULTI_SHOP เพื่อให้ backend จัดเรียง Agent ก่อน Shop
      if (self.$route.meta.jobType == "TRANSFER_TO_MULTI_SHOP") {
        query.isDestination = false;
      }

      if (
        self.$route.meta.jobType == "RETRIEVE_NEW_ITEM" ||
        self.$route.meta.jobType == "PRODUCE" ||
        self.$route.meta.jobType == "DESTROY" ||
        self.$route.meta.jobType == "TRANSFER_TO_AGENT" ||
        self.$route.meta.jobType == "REPAIR" ||
        self.$route.meta.jobType == "REPAIR_SUPPLIER" ||
        self.$route.meta.jobType == "BORROW" ||
        self.$route.meta.jobType == "HOLD_CHECKER"
      ) {
        query.types = ["PLANT"];
      } else if (self.$route.meta.jobType == "TRANSFER_TO_SHOP" || self.$route.meta.jobType == "TRANSFER_TO_MULTI_SHOP") {
        // Allow both AGENT and SHOP for both create and edit modes
        query.types = ["AGENT", "SHOP"];
      } else if (self.$route.meta.jobType == "RETURN_ADHOC") {
        query.types = ["PLANT", "AGENT", "SHOP"];
      } else if (self.$route.meta.jobType == "EXCHANGE") {
        query.types = ["PLANT", "AGENT"];
      } else if (self.$route.meta.jobType == "RETURN_SUPPLIER") {
        query.types = ["VENDOR"];
      } else if (
        self.$route.meta.jobType == "PICKUP" ||
        self.$route.meta.jobType == "RETURN" ||
        self.$route.meta.jobType == "NEW_SHOP" ||
        self.$route.meta.jobType == "PM_CHECK" ||
        self.$route.meta.jobType == "EDIT_NFC" ||
        self.$route.meta.jobType == "INSPECTIONS_AND_BORROW_PROPERTY" ||
        self.$route.meta.jobType == "QI_NO_EQUIPMENT" ||
        self.$route.meta.jobType == "TYPING_BARCODE" ||
        self.$route.meta.jobType == "QI_LESS_THAN_61" ||
        self.$route.meta.jobType == "EDIT_SHOP"
      ) {
        query.types = ["AGENT"];
      } else if (self.$route.meta.jobType == "BEER_CLAIM") {
        query.types = ["AGENT", "SHOP"];
      }

      return query;
    },
    genDestinationQuery(query) {
      var self = this;

      if (
        self.$route.meta.jobType == "RETRIEVE_NEW_ITEM" ||
        self.$route.meta.jobType == "PRODUCE" ||
        self.$route.meta.jobType == "DESTROY" ||
        self.$route.meta.jobType == "REPAIR" ||
        self.$route.meta.jobType == "RETURN" ||
        self.$route.meta.jobType == "HOLD_CHECKER"
      ) {
        query.types = ["PLANT"];
      } else if (self.$route.meta.jobType == "REPAIR_SUPPLIER") {
        query.types = ["VENDOR"];
      } else if (self.$route.meta.jobType == "TRANSFER_TO_AGENT" || self.$route.meta.jobType == "BORROW") {
        query.types = ["AGENT", "SHOP"];
      } else if (self.$route.meta.jobType == "TRANSFER_TO_SHOP") {
        // TRANSFER_TO_SHOP - logic เดิม (ไม่เปลี่ยนแปลง)
        if (self.originData && self.originData.data.locationType == "SHOP") {
          query.subAgentCode = self.originLocationId;
          query.types = ["SUBSHOP"];
        } else if ((self.originData && self.originData.data.noSML) || self.noUseSML) {
          query.agentCodeSAP = self.originLocationId;
          query.types = ["SHOP"];
        }
      } else if (self.$route.meta.jobType == "TRANSFER_TO_MULTI_SHOP") {
        // ส่ง jobType สำหรับ TRANSFER_TO_MULTI_SHOP เพื่อให้ Handler แสดงรูปแบบพิเศษ
        query.jobType = "TRANSFER_TO_MULTI_SHOP";
        // บอกว่าเป็น Destination (ไม่ใช่ Origin)
        query.isDestination = true;
        
        console.log('[genDestinationQuery] TRANSFER_TO_MULTI_SHOP - originData:', self.originData);
        
        if (self.originData && self.originData.data.locationType == "SHOP") {
          // ถ้า Origin เป็น SHOP และเป็น SubAgent (column SubAgent = 1) → แสดง SUBSHOP (L4)
          if (self.originData.data.isSubAgent || self.originData.data.subAgent == 1 || self.originData.data.subAgent === true) {
            query.subAgentCode = self.originLocationId;
            query.types = ["SUBSHOP"];
            console.log('[genDestinationQuery] Origin is SHOP (SubAgent), setting subAgentCode:', self.originLocationId, 'types: SUBSHOP');
          } else {
            // ถ้าเป็น SHOP ธรรมดา → ไม่มีปลายทางที่จะเลือก (ต้องส่งจาก Agent เท่านั้น)
            query.types = ["-1"];
            console.log('[genDestinationQuery] Origin is normal SHOP (not SubAgent), no valid destinations');
          }
        } else if (self.originData && self.originData.data.locationType == "AGENT") {
          // ถ้า Origin เป็น AGENT (L2) → แสดง SHOP ภายใต้ Agent นั้น (L3)
          query.agentCodeSAP = self.originLocationId;
          query.types = ["SHOP"];
          console.log('[genDestinationQuery] Origin is AGENT, setting agentCodeSAP:', self.originLocationId, 'types: SHOP');
        } else if ((self.originData && self.originData.data.noSML) || self.noUseSML) {
          // กรณีไม่ใช้ SML
          query.agentCodeSAP = self.originLocationId;
          query.types = ["SHOP"];
          console.log('[genDestinationQuery] Origin with noSML, setting agentCodeSAP:', self.originLocationId);
        } else {
          query.types = ["-1"];
          console.log('[genDestinationQuery] No valid origin, setting types to -1');
        }
      } else if (self.$route.meta.jobType == "EXCHANGE") {
        if (self.originData) {
          query.types = [self.originData.data.locationType];
        } else {
          query.types = ["-1"];
        }

        if (self.originData) {
          if (self.originData.data.locationType == "PLANT") {
            query.notPlantCode = self.originLocationId;
          } else if (self.originData.data.locationType == "AGENT") {
            query.notAgentCodeSAP = self.originLocationId;
          } else if (self.originData.data.locationType == "SHOP") {
            query.notShopId = self.originLocationId;
          }
        }
      } else if (self.$route.meta.jobType == "RETURN_SUPPLIER") {
        query.jobType = "RETURN_SUPPLIER";
        query.types = ["PLANT"];
      }

      return query;
    },
    onShowScanModal() {
      $(this.$refs.barcodeScanModal).modal("show");
    },
    genUserQuery(query){
      var self = this;
      var locationType = self.originData ? self.originData.data.locationType : null;
      
      if(locationType == "SHOP"){
        query.shopCode = self.originLocationId;
      }
      else if(locationType == "AGENT"){
        query.agentCode = self.originLocationId;
      }
      else if(locationType == "PLANT"){
        query.plantCode = self.originLocationId;
      }

      query.jobType = self.$route.meta.jobType; 
      return query;
    }
  },
  async mounted() {
    var self = this;
    self.uuid = self.$uuid.v1();
    self.uuid_attach = self.$uuid.v1();
    self.uuid_evidence = self.$uuid.v1();

    if(this.$root.canShow(['super_admin','MANAGE_MASTER','JOB_ADMIN_BORROW_APPROVE']) == true){
      self.isBeerClaimAdmin = true;
    }else{
      if(typeof this.$root.user.profile.role == "object"){
        const result = this.$root.user.profile.role.filter(word => word == "ADMIN_BEER_CLAIM");
        if(result.length > 0){
          self.isBeerClaimAdmin = false;
        }else{
          self.isBeerClaimAdmin = true;
        }
      }else if(typeof this.$root.user.profile.role == "string"){
        if(this.$root.user.profile.role == "ADMIN_BEER_CLAIM"){
          self.isBeerClaimAdmin = false;
        }else{
          self.isBeerClaimAdmin = true;
        }
      }else{
        self.isBeerClaimAdmin = true;
      }
    }

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    $(self.$refs.jobDate).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    self.jobDate = moment();
    $(self.$refs.jobDate)
      .datepicker("update", self.jobDate.format("DD/MM/YYYY"))
      .on("changeDate", function(e) {
        self.jobDate = moment(e.date);
      });

    $(self.$refs.jobForm).validate({
      ignore: ":hidden, .ignore",
      rules: {
        jobDate: "required",
        originLocationId: "required",
        destinationLocationId: "required",
        finishedProductCode: "required",
        transitId: self.$route.meta.jobType === "TRANSFER_TO_MULTI_SHOP" ? false : "required",
      },
      messages: {
        jobDate: "กรุณาเลือกวันที่เอกสาร",
        originLocationId: "กรุณาเลือกสถานที่ต้นทาง (Origin)",
        destinationLocationId: "กรุณาเลือกสถานที่ปลายทาง (Destination)",
        finishedProductCode: "กรุณาเลือกสินค้าที่ต้องการผลิต",
        transitId: "กรุณาเลือกรถสำหรับขนส่งสินค้า/ทรัพย์สิน",
      },
    });

    self.initDOUploader();
    self.initFileUploader();
    self.initEvidenceUploader();

    if (self.$route.params.id) {
      self.isEdit = true;

      // Edit
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังดึงข้อมูล กรุณารอสักครู่...",
      });

      var url = "/Api/Jobs/" + this.$route.params.id;
      axios
        .get(url)
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data;
            
            // เก็บข้อมูลทั้งหมดไว้ใน self.job
            self.job = data;
            
            console.log('[JobForm Edit] Full data from API:', data);
            console.log('[JobForm Edit] job.items:', data.items);
            console.log('[JobForm Edit] jobDestinations:', data.jobDestinations);
            
            self.isEditable = data.isEditable;
            self.$route.meta.jobType = data.jobType.replace("JOB_TYPE_", "");
            self.jobNumber = data.jobNumber;
            self.jobTypeName = data.jobTypeName;
            self.jobStatus = data.jobStatus;
            $(self.$refs.jobDate).datepicker("update", data.jobDate);
            self.remark = data.remark;
            self.uploadFiles = data.attachments;
            self.parentJobType = data.parentJobType;
            self.parentJobTypeName = data.parentJobTypeName;
            self.pickupAtOrigin = data.pickupAtOrigin;
            self.hasApproveProcess = data.hasApproveProcess;
            self.signatureGridFSId = data.signatureGridFSId;
            self.signatureFileUrl = data.signatureFileUrl;
            self.signatureFileInfoId = data.signatureFileInfoId;
            self.evidenceGridFSId = data.evidenceGridFSId;
            self.evidenceFileUrl = data.evidenceFileUrl;
            self.evidenceFileInfoId = data.evidenceFileInfoId;
            self.evidenceRequired = data.evidenceRequired;
            self.evidenceCanPickFromGallery = data.evidenceCanPickFromGallery;
            self.fromJobNumber = data.fromJobNumber;
            self.fromJobTypeName = data.fromJobTypeName;
            self.refJobs = data.refJobs;
            self.productLoan = data.productLoan;
          
            if (data.transitId2) {
              self.transitId2 = data.transitId2;
              setTimeout(() => {
                self.$refs.transitId2.setSelectedData({
                  id: data.transitId2,
                  text: data.transitName2,
                });
              }, 100);
            }

            for (let i = 0; i < data.items.length; i++) {
              const item = data.items[i];
              self.items.push({
                jobItemId: item.jobItemId,
                barcodeStatus: item.barcodeStatus,
                barcodeStatusName: item.barcodeStatusName,
                materialCode: item.materialCode,
                materialName: item.materialName,
                quotaId: item.quotaId,
                quotaName: item.quotaName,
                description: item.description,
                quantity: item.quantity,
                checkedQuantity: item.checkedQuantity,
                unitName: item.baseUnit,
                hasBarcode: item.hasBarcode,
                isDisabled: item.isDisabled,
                selectedBarcodeStatusData: {
                  id: item.barcodeStatus,
                  text: item.barcodeStatusName, 
                },
                selectedMaterialCodeData: {
                  id: item.materialCode,
                  text: item.materialName + " [" + item.materialCode + "]",
                  data: {
                    baseUnit: item.baseUnit,
                    materialCode: item.materialCode,
                    hasBarcode: item.hasBarcode,
                  },
                },
                productLoanReturn: item.productLoanReturn,
              });

              if (self.showItems && data.jobType != "JOB_TYPE_TRANSFER_TO_MULTI_SHOP") {
                setTimeout(function() {
                  if (self.$refs.jobItems && self.$refs.jobItems[i]) {
                    self.$refs.jobItems[i].$refs.materialCode.setSelectedData(self.items[i].selectedMaterialCodeData);

                    const matData = self.items[i].selectedMaterialCodeData;
                    if (!matData.data.hasBarcode && (data.jobType == "JOB_TYPE_BORROW" || data.jobType == "JOB_TYPE_DESTROY")) {
                      self.$refs.jobItems[i].$refs.quotaOptions.setSelectedData({
                        id: self.items[i].quotaId,
                        text: self.items[i].quotaName,
                      });
                    }
                  }
                }, 100);
              }

              if ( data.jobType == "JOB_TYPE_AUDIT_STOCK") {
                setTimeout(function() {
                  if (self.$refs.jobItems && self.$refs.jobItems[i]) {
                    self.$refs.jobItems[i].$refs.barcodeStatus.setSelectedData(self.items[i].selectedBarcodeStatusData); 
                  }
                }, 100);
              }

            }

           // alert(data.jobType);

            if (
              data.jobType == "JOB_TYPE_RETRIEVE_NEW_ITEM" ||
              data.jobType == "JOB_TYPE_DESTROY" ||
              data.jobType == "JOB_TYPE_REPAIR" ||
              data.jobType == "JOB_TYPE_HOLD_CHECKER"
            ) {
              setTimeout(function() {
                self.$refs.originLocationId.setSelectedData({
                  id: data.originLocationId,
                  text: data.originLocationName,
                  data: {
                    locationType: "PLANT",
                  },
                });
              }, 100);
            } else if (data.jobType == "JOB_TYPE_TRANSFER_TO_AGENT") {
              setTimeout(function() {
                self.$refs.transitId.setSelectedData({
                  id: data.transitId,
                  text: data.transitName,
                });

                self.$refs.originLocationId.setSelectedData({
                  id: data.originLocationId,
                  text: data.originLocationName,
                  data: {
                    locationType: "PLANT",
                  },
                });

                // if (self.pickupAtOrigin) {
                //   self.$refs.destinationLocationId.setSelectedData({
                //     id: data.destinationLocationId,
                //     text: data.destinationLocationName,
                //     data: {
                //       locationType: "AGENT"
                //     }
                //   });
                // }
              }, 100);
            } else if (data.jobType == "JOB_TYPE_BORROW") {
              setTimeout(function() {
                if (self.$refs.transitId !== undefined) {
                  self.$refs.transitId.setSelectedData({
                    id: data.transitId,
                    text: data.transitName,
                  });
                }

                if (self.$refs.originLocationId !== undefined) {
                  self.$refs.originLocationId.setSelectedData({
                    id: data.originLocationId,
                    text: data.originLocationName,
                    data: {
                      locationType: data.originLocationType,
                    },
                  });
                }

                if (data.destinationLocationId) {
                  setTimeout(function() {
                    if (self.$refs.destinationLocationId !== undefined) {
                      self.$refs.destinationLocationId.setSelectedData({
                        id: data.destinationLocationId,
                        text: data.destinationLocationName,
                        data: {
                          locationType: data.destinationLocationType,
                        },
                      });
                    }
                  }, 100);
                }
              }, 100);
            } else if (data.jobType == "JOB_TYPE_PRODUCE") {
              setTimeout(function() {
                self.$refs.originLocationId.setSelectedData({
                  id: data.originLocationId,
                  text: data.originLocationName,
                  data: {
                    locationType: "PLANT",
                  },
                });

                self.$refs.finishedProductCode.setSelectedData({
                  id: data.finishedProductCode,
                  text: data.finishedProductName + " [" + data.finishedProductCode + "]",
                });
              }, 100);
            } else if (data.jobType == "JOB_TYPE_RETRIEVE_ITEM") {
              setTimeout(function() {
                if (data.transitId) {
                  self.$refs.transitId.setSelectedData({
                    id: data.transitId,
                    text: data.transitName,
                  });
                }

                self.$refs.originLocationId.setSelectedData({
                  id: data.originLocationId,
                  text: data.originLocationName,
                  data: {
                    locationType: data.originLocationId.length == 7 ? "AGENT" : data.originLocationId.length == 4 ? "PLANT" : "SHOP",
                    noSML: data.originNoSML,
                  },
                });

                setTimeout(() => {
                  self.noUseSML = data.noUseSML;
                }, 100);

                setTimeout(function() {
                  self.$refs.destinationLocationId.setSelectedData({
                    id: data.destinationLocationId,
                    text: data.destinationLocationName,
                    data: {
                      locationType: data.destinationLocationId.length == 7 ? "AGENT" : data.destinationLocationId.length == 4 ? "PLANT" : "SHOP",
                    },
                  });
                }, 100);
                
              }, 100);
            } else if (data.jobType == "JOB_TYPE_REPAIR_SUPPLIER") {
              setTimeout(function() {
                self.$refs.originLocationId.setSelectedData({
                  id: data.originLocationId,
                  text: data.originLocationName,
                  data: {
                    locationType: "PLANT",
                  },
                });

                setTimeout(function() {
                  self.$refs.destinationLocationId.setSelectedData({
                    id: data.destinationLocationId,
                    text: data.destinationLocationName,
                    data: {
                      locationType: "VENDOR",
                    },
                  });
                }, 100);
              }, 100);
            } else if (data.jobType == "JOB_TYPE_RETURN_SUPPLIER") {
              setTimeout(function() {
                self.$refs.originLocationId.setSelectedData({
                  id: data.originLocationId,
                  text: data.originLocationName,
                  data: {
                    locationType: "VENDOR",
                  },
                });

                setTimeout(function() {
                  self.$refs.destinationLocationId.setSelectedData({
                    id: data.destinationLocationId,
                    text: data.destinationLocationName,
                    data: {
                      locationType: "PLANT",
                    },
                  });
                }, 100);
              }, 100);
            } else if (data.jobType == "JOB_TYPE_RETURN") {
              setTimeout(function() {
                self.$refs.transitId.setSelectedData({
                  id: data.transitId,
                  text: data.transitName,
                });

                self.$refs.originLocationId.setSelectedData({
                  id: data.originLocationId,
                  text: data.originLocationName,
                  data: {
                    locationType: "AGENT",
                    noSML: data.originNoSML,
                  },
                });

                setTimeout(() => {
                  self.noUseSML = data.noUseSML;
                }, 100);

                setTimeout(function() {
                  self.$refs.destinationLocationId.setSelectedData({
                    id: data.destinationLocationId,
                    text: data.destinationLocationName,
                    data: {
                      locationType: "PLANT",
                    },
                  });
                }, 100);

                //jobAssignToUsers
                if(data.jobAssignToUsers.length > 0){
                  setTimeout(() => {
                    var userOptions = $.map(data.jobAssignToUsers, function(obj, idx) {
                      return {
                        id: obj.assignToUserId,
                        text: obj.displayName,
                      };
                    });
                    self.$refs.userIds.setSelectedData(userOptions);
                  }, 100);
                }

              }, 100);
            }else if (data.jobType == "JOB_TYPE_AUDIT_STOCK") {
              setTimeout(function() {
                

                self.$refs.originLocationId.setSelectedData({
                  id: data.originLocationId,
                  text: data.originLocationName,
                  data: {
                    locationType: "AGENT",
                    noSML: data.originNoSML,
                  },
                });
 
 

              }, 100);
            } else if (data.jobType == "JOB_TYPE_PICKUP" || data.jobType == "JOB_TYPE_RETURN_ADHOC") {

              
              if(data.jobStatusCode != "JOB_STATUS_SUCCESS" && data.jobStatusCode != "JOB_STATUS_PICKUP")
              {
                self.isEdit = true;
              }
              else{
                self.isEdit = false;
              }

              self.isPreviousBalance = data.isPreviousBalance;
              self.isEditableTypePICKUP = false ;

              setTimeout(function() {
                self.$refs.originLocationId.setSelectedData({
                  id: data.originLocationId,
                  text: data.originLocationName,
                  data: {
                    locationType: data.originLocationType,
                    noSML: data.originNoSML,
                    isPreviousBalance : data.originIsPreviousBalance
                  },
                });
              }, 100);

              //jobAssignToUsers
              if(data.jobAssignToUsers.length > 0){
                setTimeout(() => {
                  var userOptions = $.map(data.jobAssignToUsers, function(obj, idx) {
                    return {
                      id: obj.assignToUserId,
                      text: obj.displayName,
                    };
                  });
                  self.$refs.userIds.setSelectedData(userOptions);
                }, 100);
              }

              setTimeout(() => {
                  self.noUseSML = data.noUseSML;
              }, 100);

            } else if (data.jobType == "JOB_TYPE_TRANSFER_TO_SHOP") {
              setTimeout(function() {
                self.$refs.originLocationId.setSelectedData({
                  id: data.originLocationId,
                  text: data.originLocationName,
                  data: {
                    locationType: data.originLocationType,
                    noSML: data.originNoSML,
                  },
                });
                setTimeout(() => {
                  self.noUseSML = data.noUseSML;
                }, 100);

                if (data.originLocationId != data.destinationLocationId) {
                  setTimeout(function() {
                    // ต้องรอ origin เข้า onchange event ก่อน จึงจะ set ได้
                    // หน่วงเวลา
                    if (self.$refs.destinationLocationId !== undefined) {
                      self.$refs.destinationLocationId.setSelectedData({
                        id: data.destinationLocationId,
                        text: data.destinationLocationName,
                        data: {
                          locationType: data.destinationLocationType,
                        },
                      });
                    }
                  }, 100);
                }

                //jobAssignToUsers
                if(data.jobAssignToUsers.length > 0){
                  setTimeout(() => {
                    var userOptions = $.map(data.jobAssignToUsers, function(obj, idx) {
                      return {
                        id: obj.assignToUserId,
                        text: obj.displayName,
                      };
                    });
                    self.$refs.userIds.setSelectedData(userOptions);
                  }, 100);
                }
              }, 100);
            } else if (data.jobType == "JOB_TYPE_TRANSFER_TO_MULTI_SHOP") {
              setTimeout(function() {
                // Set Transit (รถ)
                if (data.transitId && self.$refs.transitId) {
                  self.$refs.transitId.setSelectedData({
                    id: data.transitId,
                    text: data.transitName,
                  });
                }
                
                // Set Origin
                self.$refs.originLocationId.setSelectedData({
                  id: data.originLocationId,
                  text: data.originLocationName,
                  data: {
                    locationType: data.originLocationType,
                    noSML: data.originNoSML,
                  },
                });
                
                setTimeout(() => {
                  self.noUseSML = data.noUseSML;
                }, 100);

                // Load JobDestinations
                console.log('[TRANSFER_TO_MULTI_SHOP] Raw data from API:', data);
                console.log('[TRANSFER_TO_MULTI_SHOP] jobDestinations:', data.jobDestinations);
                
                if (data.jobDestinations && data.jobDestinations.length > 0) {
                  self.jobDestinations = data.jobDestinations.map(dest => ({
                    _uid: self.nextDestinationUid++, // Assign unique ID when loading from API
                    destinationLocationId: dest.destinationLocationId,
                    destinationName: dest.destinationName,
                    items: dest.items || []
                  }));
                  console.log('[TRANSFER_TO_MULTI_SHOP] Loaded jobDestinations:', self.jobDestinations);
                }

                // jobAssignToUsers
                if(data.jobAssignToUsers && data.jobAssignToUsers.length > 0){
                  setTimeout(() => {
                    var userOptions = $.map(data.jobAssignToUsers, function(obj, idx) {
                      return {
                        id: obj.assignToUserId,
                        text: obj.displayName,
                      };
                    });
                    self.$refs.userIds.setSelectedData(userOptions);
                  }, 100);
                }
              }, 100);
            } else if (data.jobType == "JOB_TYPE_EXCHANGE") {
              setTimeout(function() {
                self.$refs.transitId.setSelectedData({
                  id: data.transitId,
                  text: data.transitName,
                });

                self.$refs.originLocationId.setSelectedData({
                  id: data.originLocationId,
                  text: data.originLocationName,
                  data: {
                    locationType: data.originLocationId.length == 7 ? "AGENT" : data.originLocationId.length == 4 ? "PLANT" : "SHOP",
                    noSML: data.originNoSML,
                  },
                });

                setTimeout(() => {
                  self.noUseSML = data.noUseSML;
                }, 100);

                setTimeout(function() {
                  self.$refs.destinationLocationId.setSelectedData({
                    id: data.destinationLocationId,
                    text: data.destinationLocationName,
                    data: {
                      locationType: data.destinationLocationId.length == 7 ? "AGENT" : data.destinationLocationId.length == 4 ? "PLANT" : "SHOP",
                    },
                  });
                }, 100);

                //jobAssignToUsers
                if(data.jobAssignToUsers.length > 0){
                  setTimeout(() => {
                    var userOptions = $.map(data.jobAssignToUsers, function(obj, idx) {
                      return {
                        id: obj.assignToUserId,
                        text: obj.displayName,
                      };
                    });
                    self.$refs.userIds.setSelectedData(userOptions);
                  }, 100);
                }
              }, 100);
            } else if (data.jobType == "JOB_TYPE_NEW_SHOP") {
              setTimeout(function() {
                self.$refs.originLocationId.setSelectedData({
                  id: data.originLocationId,
                  text: data.originLocationName,
                  data: {
                    locationType: "AGENT",
                  },
                });
              }, 100);
            } else if (data.jobType == "JOB_TYPE_PM_CHECK") {

              // if (data.destinationLocationId) {
              //     setTimeout(function() {
              //       self.$refs.destinationLocationId.setSelectedData({
              //         id: data.destinationLocationId,
              //         text: data.destinationLocationName,
              //         data: {
              //           locationType: data.destinationLocationType,
              //         },
              //       });
              //     }, 100);
              //   }

              if(data.destinationLocationId &&  data.destinationLocationType == 'SUBSHOP'){
                setTimeout(function() {
                  self.$refs.originLocationId.setSelectedData({
                    id: data.destinationLocationId,
                    text: data.destinationLocationName,
                    data: {
                      locationType: "SUBSHOP",
                    },
                  }); 
                }, 100);
              }
              else{
                setTimeout(function() {
                  self.$refs.originLocationId.setSelectedData({
                    id: data.originLocationId,
                    text: data.originLocationName,
                    data: {
                      locationType: "SHOP",
                    },
                  }); 
                }, 100);
              }

             

            } else if (data.jobType == "JOB_TYPE_EDIT_NFC") {
              setTimeout(function() {
                self.$refs.originLocationId.setSelectedData({
                  id: data.originLocationId,
                  text: data.originLocationName,
                  data: {
                    locationType: "SHOP",
                  },
                });
              }, 100);
            } else if (
              data.jobType == "JOB_TYPE_INSPECTIONS_AND_BORROW_PROPERTY"
            ) {
              setTimeout(function() {
                self.$refs.originLocationId.setSelectedData({
                  id: data.originLocationId,
                  text: data.originLocationName,
                  data: {
                    locationType: "SHOP",
                  },
                });
              }, 100);
            } else if (data.jobType == "JOB_TYPE_BEER_CLAIM") {
              setTimeout(function() {
                self.$refs.originLocationId.setSelectedData({
                  id: data.originLocationId,
                  text: data.originLocationName,
                  data: {
                    locationType:
                      data.destinationLocationId.length == 7 ? "AGENT" : "SHOP",
                  },
                });

                setTimeout(function() {
                  self.$refs.destinationLocationId.setSelectedData({
                    id: data.destinationLocationId,
                    text: data.destinationLocationName,
                    data: {
                      locationType: data.destinationLocationType,
                    },
                  });
                }, 100);
              }, 100);
            } else if (data.jobType == "JOB_TYPE_QI_NO_EQUIPMENT") {
              setTimeout(function() {
                self.$refs.originLocationId.setSelectedData({
                  id: data.originLocationId,
                  text: data.originLocationName,
                  data: {
                    locationType: "SHOP",
                  },
                });
              }, 100);
            } else if (data.jobType == "JOB_TYPE_TYPING_BARCODE") {
              setTimeout(function() {
                self.$refs.originLocationId.setSelectedData({
                  id: data.originLocationId,
                  text: data.originLocationName,
                  data: {
                    locationType: "SHOP",
                  },
                });
              }, 100);
            } else if (data.jobType == "JOB_TYPE_QI_LESS_THAN_61") {
              setTimeout(function() {
                self.$refs.originLocationId.setSelectedData({
                  id: data.originLocationId,
                  text: data.originLocationName,
                  data: {
                    locationType: "SHOP",
                  },
                });
              }, 100);
            } else if (data.jobType == "JOB_TYPE_EDIT_SHOP") {
              setTimeout(function() {
                self.$refs.originLocationId.setSelectedData({
                  id: data.originLocationId,
                  text: data.originLocationName,
                  data: {
                    locationType: "AGENT",
                  },
                });
              }, 100);
            }

            if (data.jobType == "JOB_TYPE_PICKUP") {
              if (data.jobStatus == "JOB_STATUS_SUCCESS" || data.jobStatus == "JOB_STATUS_PICKUP") {
                self.showItems = false;
              }
              self.shopItems = data.shopItems;
              self.shopReturnItems = data.shopReturnItems;
              self.pickupItems = data.pickupItems;
              self.pickupReturnItems = data.pickupReturnItems;

              setTimeout(() => {
                for (let i = 0; i < self.shopItems.length; i++) {
                  const item = self.shopItems[i];
                  if (item.shopCode) {
                    self.$refs.shopCodes[i].setSelectedData({
                      id: item.shopCode,
                      text: item.shopCodeName,
                    });
                  }
                }
              }, 100);

              if(data.noUseSML && data.jobStatus != "JOB_STATUS_WAITING"){
                self.ItemHistory = data.itemHistory
              }
            }

            setTimeout(() => {
              self.refDocuments = data.refDocuments;
              self.refInvoices = data.refInvoices;
              self.isTransitInit = true;

              setTimeout(() => {
                $(".sml-bill-number.required").each(function() {
                  const $input = $(this);
                  $input.rules("add", {
                    required: true,
                    messages: {
                      required: "กรุณากรอกเลขที่บิลขาย",
                    },
                  });
                });

                self.initDOUploader();
                self.initFileUploader();
                self.initEvidenceUploader();
              }, 100);
            }, 100);
          } else {
            Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลลูกค้าที่คุณเลือก", "warning");
            KTApp.unblockPage();
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลลูกค้าได้ในขณะนี้", "error");
          KTApp.unblockPage();
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });

      $(self.$refs.barcodeLocalTable).DataTable({
        responsive: true,
        data: this.localBarcodes,

        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
            <'row'<'col-sm-12'tr>>
            <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

        lengthMenu: [50, 100, 200, 500],

        pageLength: 100,

        language: {
          lengthMenu: "Display _MENU_",
        },

        // Order settings
        order: [[1, "desc"]],

        columns: [
          {
            className: "text-center",
            width: "5%",
            sortable: false,
          },
          { className: "text-center", width: "20%" },
          { className: "text-center", width: "20%" },
          {
            className: "text-center",
            width: "20%",
          },
          { className: "text-center" },
        ],

        drawCallback: function(settings) {
          for (var i = 0, iLen = settings._iDisplayLength; i < iLen; i++) {
            $("tbody tr:eq(" + i + ") td:eq(0)", self.$refs.barcodeLocalTable).html(settings._iDisplayStart + i + 1);
          }

          $('[data-toggle="popover"]', self.$refs.barcodeLocalTable).popover();
        },
      });

      $(self.$refs.barcodeScanTable).DataTable({
        responsive: true,
        data: this.scanBarcodeResults,

        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
            <'row'<'col-sm-12'tr>>
            <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

        lengthMenu: [50, 100, 200, 500],

        pageLength: 100,

        language: {
          lengthMenu: "Display _MENU_",
        },

        // Order settings
        order: [[1, "desc"]],

        columns: [
          {
            data: "barcodeNo",
            className: "text-center",
            width: "5%",
            sortable: false,
          },
          { data: "barcodeNoOld", className: "text-center", width: "20%" },
          { data: "departmentMaterialCode", className: "text-center", width: "20%" },
          { data: "message", className: "text-center" },
        ],

        drawCallback: function(settings) {
          // Need to redo the counters if filtered or sorted
          for (var i = 0, iLen = settings._iDisplayLength; i < iLen; i++) {
            $("tbody tr:eq(" + i + ") td:eq(0)", self.$refs.barcodeScanTable).html(settings._iDisplayStart + i + 1);
          }

          $('[data-toggle="popover"]', self.$refs.barcodeScanTable).popover();
        },
      });
    } else {
      // Create
      axios
        .post(
          "/Api/MasterLocation/Select2JobLocation",
          self.genOriginQuery({
            search: "",
            page: 1,
          })
        )
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data;
            
            // Debug: Log to see what API returns
            console.log('[TRANSFER_TO_MULTI_SHOP] Origin API Response:', data.results);
            
            if (data.results.length > 0) {
              var firstOrigin = data.results[0];
 
              
              // For TRANSFER_TO_SHOP and TRANSFER_TO_MULTI_SHOP, prefer AGENT over SHOP as default
              if (self.$route.meta.jobType == "TRANSFER_TO_SHOP" || self.$route.meta.jobType == "TRANSFER_TO_MULTI_SHOP" || self.$route.meta.jobType == "AUDIT_STOCK") {
           
                var agentOrigin = data.results.find(function(item) {
                  return item.data && item.data.locationType == "AGENT";
                });
                console.log('[TRANSFER_TO_MULTI_SHOP] Found AGENT:', agentOrigin);
                if (agentOrigin) {
                  firstOrigin = agentOrigin;
                }
              }
              
              console.log('[TRANSFER_TO_MULTI_SHOP] Setting default origin:', firstOrigin);
              self.$refs.originLocationId.setSelectedData(firstOrigin);
              
              // Manually trigger onOriginLocationChange to set originData
              setTimeout(() => {
                if (self.$refs.originLocationId) {
                  let originEl = self.$refs.originLocationId.$el;
                  let selectedData = $(originEl).select2("data");
                  console.log('[TRANSFER_TO_MULTI_SHOP] After setSelectedData, select2 data:', selectedData);
                  if (selectedData.length > 0) {
                    self.onOriginLocationChange(
                      selectedData[0].id,
                      selectedData[0].id,
                      selectedData,
                      self.$refs.originLocationId
                    );
                  }
                }
              }, 100);
            }
          }
        })
        .finally(function() {
          // Skip auto-selecting destination for TRANSFER_TO_MULTI_SHOP (uses multiple destinations)
          if (self.$route.meta.jobType != "EXCHANGE" && self.$route.meta.jobType != "TRANSFER_TO_MULTI_SHOP") {
            setTimeout(() => {
              axios
                .post(
                  "/Api/MasterLocation/Select2JobLocation",
                  self.genDestinationQuery({
                    search: "",
                    page: 1,
                  })
                )
                .then(function(response) {
                  if (response.status == 200) {
                    var data = response.data;
                    if (data.results.length > 0) {
                      var firstDestination = data.results[0];
                      if (firstDestination && self.$refs.destinationLocationId !== undefined) {
                        self.$refs.destinationLocationId.setSelectedData(
                          firstDestination
                        );
                      }
                    }
                  }
                });
            }, 100);
          }
        });
    }
  },
  computed: {
    // showOriginLocation() {
    //   return this.isShowOnJobTypes([
    //     "TRANSFER_TO_AGENT",
    //     "TRANSFER_TO_SHOP",
    //     "EXCHANGE",
    //     "BORROW",
    //     ["RETRIEVE_ITEM", "JOB_TYPE_TRANSFER_TO_AGENT"],
    //     ["RETRIEVE_ITEM", "JOB_TYPE_TRANSFER_TO_SHOP"],
    //     ["RETRIEVE_ITEM", "JOB_TYPE_EXCHANGE"],
    //     ["RETRIEVE_ITEM", "JOB_TYPE_BORROW"],
    //   ]);
    // },
    // showDestinationLocation() {
    //   return (
    //     // this.originLocationId != this.destinationLocationId &&
    //     this.isShowOnJobTypes([
    //       "RETRIEVE_ITEM",
    //       "REPAIR_SUPPLIER",
    //       "RETURN_SUPPLIER",
    //       "RETURN",
    //       "EXCHANGE",
    //       "BEER_CLAIM",
    //     ]) ||
    //     (this.$route.meta.jobType == "BORROW" && !this.pickupAtOrigin) ||
    //     (this.$route.meta.jobType == "TRANSFER_TO_SHOP" &&
    //       this.originData &&
    //       this.originData.data.locationType == "SHOP") ||
    //     (this.$route.meta.jobType == "TRANSFER_TO_SHOP" &&
    //       this.originData &&
    //       (this.originData.data.noSML || this.noUseSML))
    //   );
    // },
    showSmlBillNumber() {
      //return !(this.originData && this.originData.data.locationType == "AGENT" && this.originData.data.noSML);
      return (this.originData && this.originData.data.locationType == "AGENT" && !this.originData.data.noSML && !this.noUseSML);
    },
    showRefInvoices() {
      //console.log("showRefInvoices");
      if (this.originData) {
          return (this.isShowOnJobTypes([
                'RETURN', ['RETRIEVE_ITEM', 'JOB_TYPE_RETURN'],
                'EXCHANGE', ['RETRIEVE_ITEM', 'JOB_TYPE_EXCHANGE'],
                'PICKUP', ['RETRIEVE_ITEM', 'JOB_TYPE_PICKUP'],
              ]) &&
              this.originData.data.locationType == 'AGENT' &&
              !this.originData.data.noSML &&
              !this.noUseSML);
              
        //   return (
        //     this.isShowOnJobTypes([
        //       "PICKUP",
        //       "RETURN",
        //       "EXCHANGE",
        //       ["RETRIEVE_ITEM", "JOB_TYPE_PICKUP"],
        //       ["RETRIEVE_ITEM", "JOB_TYPE_RETURN"],
        //       ["RETRIEVE_ITEM", "JOB_TYPE_EXCHANGE"],
        //     ]) &&
        //     !(this.originData.data.locationType == "AGENT" && this.originData.data.noSML) &&
        //     this.originData.data.locationType != "PLANT"
        //   );
      
      } else {
        return this.isShowOnJobTypes(["PICKUP", "RETURN", ["RETRIEVE_ITEM", "JOB_TYPE_PICKUP"]]);
      }
    },
    canPickupAtOrigin() {
      let self = this;
      let shipTos = [];

      self.refDocuments.forEach((doc) => {
        let exists = $.grep(shipTos, function(obj, idx) {
          return obj == doc.shipTo;
        });

        if (exists.length == 0) {
          shipTos.push(doc.shipTo);
        }
      });

      self.refInvoices.forEach((doc) => {
        let exists = $.grep(shipTos, function(obj, idx) {
          return obj == doc.shipTo;
        });

        if (exists.length == 0) {
          shipTos.push(doc.shipTo);
        }
      });

      if (shipTos.length <= 1) {
        return true;
      } else {
        self.pickupAtOrigin = false; // reset
        return false;
      }
    },
    canPickupAtOriginMultiShop() {
      let self = this;
      
      // สำหรับ TRANSFER_TO_MULTI_SHOP ตรวจสอบจำนวน destinations
      if (self.$route.meta.jobType == "TRANSFER_TO_MULTI_SHOP") {
        if (self.jobDestinations.length <= 1) {
          return true;
        } else {
          self.pickupAtOrigin = false; // uncheck และ disable เมื่อมีมากกว่า 1 ปลายทาง
          return false;
        }
      }
      
      // สำหรับ job types อื่นๆ ใช้ logic เดิม
      return self.canPickupAtOrigin;
    },
  },
  watch: {
    "$refs.destinationLocationId"(newValue, oldValue) {
      if (newValue && !oldValue && this.destinationData) {
      }
    },
    // Watch jobDestinations length สำหรับ TRANSFER_TO_MULTI_SHOP
    "jobDestinations.length": function(newLength, oldLength) {
      if (this.$route.meta.jobType == "TRANSFER_TO_MULTI_SHOP") {
        // ถ้ามีปลายทางมากกว่า 1 → uncheck pickupAtOrigin
        if (newLength > 1 && this.pickupAtOrigin) {
          this.pickupAtOrigin = false;
          console.log('[TRANSFER_TO_MULTI_SHOP] Unchecked pickupAtOrigin because destinations > 1');
        }
      }
    }
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Job/JobForm.vue